var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "Alta Verapaz": {
    "Coban": {
      "Canguinic, Ruta a Playa Grande": true,
      "Cerro Lindo": true,
      "Chichaic": true,
      "Chicoj": true,
      "Chicuxab": true,
      "Chinaichab": true,
      "Chincijay Ruta A Chisec": true,
      "Chirretzaaj": true,
      "Coban": true,
      "Corozal, Ruta a Playa Grande": true,
      "Cubil": true,
      "Cubilguitz": true,
      "El Rosario": true,
      "Las Pacayas": true,
      "Pequixul": true,
      "Salacuin": true,
      "Samac": true,
      "San Antonio Las Flores": true,
      "Saolon Ruta A Playa Grande": true,
      "Sibicte": true,
      "Siguana": true,
      "Sonte": true,
      "Tanchi": true,
      "Tomten": true,
      "Ucula": true,
      "Zona 1": true,
      "Zona 10": true,
      "Zona 11": true,
      "Zona 12": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5, Cobán": true,
      "Zona 6": true,
      "Zona 7": true,
      "Zona 8": true,
      "Zona 9": true
    },
    "Santa Cruz Verapaz": {
      "Chijaxau": true,
      "Chijou": true,
      "Chitul": true,
      "Las Cuevas": true,
      "Las Islas": true,
      "Le Peña Del Gallo": true,
      "Pueblo Viejo Ruta A Coban": true,
      "San Jose": true,
      "Santa Cruz Verapaz": true,
      "Valparaiso": true
    },
    "San Cristobal Verapaz": {
      "Chiyuc": true,
      "Nisnic": true,
      "Paniste": true,
      "San Cristobal": true,
      "San Cristobal Verapaz": true
    },
    "Tactic": {
      "Chiacal": true,
      "Chiixim": true,
      "Panmisti": true,
      "Pansinic": true,
      "Pasmolon Ruta A Coban": true,
      "San Julian Cruce Para El Polochic": true,
      "Tactic": true,
      "Tampo": true,
      "Tampur": true
    },
    "Tamahu": {
      "Agroxintun": true,
      "Chimolon": true,
      "Chiquixguashcux": true,
      "Chulumja": true,
      "Cruce San Julian": true,
      "Jolomche": true,
      "Pantic": true,
      "Santa Teresa": true,
      "Tamahu": true,
      "Yushilja": true
    },
    "Tucuru": {
      "Aldea Nuevo Chixtun": true,
      "Canaan": true,
      "Chibich Ruta Del Polochic": true,
      "Chicoban": true,
      "Comunidad San Carlos": true,
      "Comunidad San Green": true,
      "Pancajche": true,
      "Papalja": true,
      "Raxquix": true,
      "Tucuru": true,
      "Waxpon": true
    },
    "Panzos": {
      "Agua Caliente": true,
      "Panzos": true,
      "Soledad": true,
      "Teleman": true,
      "Xucub": true
    },
    "Senahu": {
      "Palin": true,
      "San Nicolas": true,
      "Seamay": true,
      "Senahu": true
    },
    "San Pedro Carcha": {
      "Aldea Chelac": true,
      "Aldea China Coyou": true,
      "Aldea Chiqueleu": true,
      "Aldea El Pajal": true,
      "Bancav": true,
      "Cabañas": true,
      "Campur": true,
      "Chaipec": true,
      "Chanquej": true,
      "Chicojl": true,
      "Chirrequiche": true,
      "Cojaj": true,
      "Cruce Chamtaca": true,
      "Muyha": true,
      "San Antonio Las Cuevas": true,
      "San Pedro Carcha": true,
      "Tzunut": true,
      "Zacanilla": true
    },
    "San Juan Chamelco": {
      "Chiu": true,
      "Cruce Pocola": true,
      "Cuevas Del Rey Marcos": true,
      "San Juan Chamelco": true,
      "San Luis": true,
      "San Marcos": true,
      "Santa Cecilia": true,
      "Sesijche": true
    },
    "Lanquin": {
      "Lanquin": true
    },
    "Cahabon": {
      "Cahabon": true,
      "La Union": true,
      "Santa Maria Cahabon": true,
      "Saquija": true,
      "Sequixquib": true,
      "Sexoy": true
    },
    "Chisec": {
      "Ald. Nacimiento": true,
      "Aldea Candelaria": true,
      "Aldea Carolina": true,
      "Aldea El Limon": true,
      "Aldea Las Promesas": true,
      "Aldea Limon Imperial": true,
      "Aldea Limon Norte": true,
      "Aldea Limon Sur": true,
      "Aldea Paraiso": true,
      "Aldea San Benito": true,
      "Aldea San Jose Icbolay": true,
      "Aldea San Luis Lachua": true,
      "Aldea Tierra Linda": true,
      "Aldea Verapaz": true,
      "Batbazul": true,
      "Canahan": true,
      "Canlech": true,
      "Caserio Tuberia": true,
      "Chajmacan Ruta A Chisec": true,
      "Chichut Chisec": true,
      "Chiquibul": true,
      "Chisec": true,
      "Chitocan": true,
      "Cruce De San Antonio": true,
      "El Paraiso Ruta A Playa Grande": true,
      "El Sauce Chisec Ruta A Tierra Blanca": true,
      "La Caoba": true,
      "Monte Cristo Chisec Ruta A Tierra Blanca": true,
      "Playitas": true,
      "Raxquiche": true,
      "Rubelsanto": true,
      "Sachichaj": true,
      "Samaria Chisec Ruta A Tierra Blanca": true,
      "Samococh Ruta Coban A Peten": true,
      "Santa Lucia Lachua": true,
      "Sechaj": true,
      "Secocpur": true,
      "Semococh": true,
      "Semuy": true,
      "Sidicte": true,
      "Trece Aguas": true,
      "Xuctul Ruta A Raxruha, Chisec": true,
      "Yalpemech": true
    },
    "Chahal": {
      "Chahal": true,
      "San Agustin El Chahal": true
    },
    "Fray Bartolome De Las Casas": {
      "Aldea Centro Champeguano": true,
      "Aldea China Cobeja": true,
      "Aldea Nuevo Secapur": true,
      "Bolonco": true,
      "Caserio Chimenja": true,
      "Fray Bartolome De Las Casas": true,
      "Yalitzul": true
    },
    "Santa Catalina La Tinta": {
      "Campur": true,
      "La Tinta": true,
      "Matucuy": true,
      "Sacxuja": true,
      "Salac": true,
      "Santa Catalina La Tinta": true,
      "Xicuc": true
    },
    "Raxruha": {
      "28 De Septiembre": true,
      "Ald. San Antonio Las Flores": true,
      "El Ranchon": true,
      "Lachua": true,
      "Zona Urbana": true
    },
    "Santa Maria Cahabon": {
      "Raxhujá": true
    }
  },
  "Baja Verapaz": {
    "Salama": {
      "Cachil": true,
      "Caserio Las Palmas": true,
      "El Tempisque": true,
      "El Tunal": true,
      "La Paz I": true,
      "La Paz Ii": true,
      "Las Anonas": true,
      "Las Tunas": true,
      "Los Limones": true,
      "Paso Ancho": true,
      "Payaque": true,
      "Salama": true,
      "San Ignacio": true,
      "San Juan": true,
      "San Juan I": true,
      "San Juan Ii": true,
      "Santa Marta": true
    },
    "San Miguel Chicaj": {
      "Aldea Chilajom": true,
      "Aldea Xixoloc": true,
      "El Progreso I San Gabriel": true,
      "El Progreso Ii San Gabriel": true,
      "Rincon De Jesus": true,
      "San Francisco": true,
      "San Gabriel Pansuj": true,
      "San Miguel Chicaj": true
    },
    "Rabinal": {
      "Chiticoy": true,
      "Chuaperol": true,
      "Pichec": true,
      "Rabinal": true,
      "Sutun Rabinal": true,
      "Xolocoy Rabinal": true
    },
    "Cubulco": {
      "Cubulco": true
    },
    "Granados": {
      "Aldea Los Pozos": true,
      "El Guapinol Granados": true,
      "El Sacramento Granados": true,
      "El Zapote": true,
      "Granados": true,
      "La Canoa": true,
      "Las Animas": true,
      "Las Dandas": true,
      "Las Marias": true,
      "Llano Grande": true,
      "Los Cerritos Saltan": true,
      "Los Dantas Granados": true,
      "Los Paxtes": true,
      "Los Planes": true,
      "Oratorio Baja Verapaz": true,
      "Potrero Grande Granados": true,
      "Saltan": true,
      "San Vicente Baja Verapaz": true,
      "San Vicente Granados": true,
      "Zuasite": true
    },
    "Santa Cruz El Chol": {
      "Chiquirines": true,
      "El Chol": true,
      "El Platanal": true,
      "Las Margaritas": true,
      "Los Jobos": true,
      "Los Lochuyes": true,
      "Pueblo Nuevo": true,
      "Santa Cruz El Chol": true,
      "Trapiche Viejo": true
    },
    "San Jeronimo": {
      "Cañas Viejas": true,
      "Chilasco": true,
      "Cumbre Santa Elena": true,
      "El Astillero": true,
      "El Cacao": true,
      "El Durazno": true,
      "El Monjon": true,
      "La Union Barrios": true,
      "Las Limas": true,
      "Los Jocotes": true,
      "Los Ramones": true,
      "Matanzas": true,
      "Niño Perdido": true,
      "San Jeronimo": true,
      "Santa Barbara": true,
      "Santa Catarina": true,
      "Sibabaj": true
    },
    "Purulha": {
      "Chicoy": true,
      "El Comunal": true,
      "El Durazno": true,
      "Los Encuentros": true,
      "Papal": true,
      "Purulha": true,
      "Rincon Del Quetzal": true
    }
  },
  "Chimaltenango": {
    "Chimaltenango": {
      "Chimaltenango": true,
      "Colonia Puerto Rico": true,
      "La Alameda": true,
      "Los Aposentos": true
    },
    "San Jose Poaquil": {
      "San Jose Poaquil": true
    },
    "San Martin Jilotepeque": {
      "Aldea Las Escobas": true,
      "La Vega De Godinez": true,
      "Las Escobas": true,
      "San Martin Jilotepeque": true
    },
    "San Juan Comalapa": {
      "San Juan Comalapa": true
    },
    "Santa Apolonia": {
      "Santa Apolonia": true
    },
    "Tecpan Guatemala": {
      "Aldea Chirijuyu": true,
      "Tecpan": true
    },
    "Patzun": {
      "Patzun": true
    },
    "Pochuta": {
      "San Miguel Pochuta": true
    },
    "Patzicia": {
      "El Caman": true,
      "Patzicia": true
    },
    "Santa Cruz Balanya": {
      "Aldea Chimazat": true,
      "Santa Cruz Balanya": true
    },
    "Acatenango": {
      "Acatenango": true,
      "Pajales I": true,
      "Pajales Ii": true,
      "San Antonio Nejapa": true
    },
    "San Pedro Yepocapa": {
      "San Pedro Yepocapa": true
    },
    "San Andres Iztapa": {
      "San Andres Itzapa": true
    },
    "Parramos": {
      "Parramos": true
    },
    "Zaragoza": {
      "Aldea Rincon Chiquito": true,
      "Aldea Rincon Grande": true,
      "Zaragoza": true
    },
    "El Tejar": {
      "El Tejar": true
    }
  },
  "Chiquimula": {
    "Chiquimula": {
      "Banvi": true,
      "Barrio El Jurgallon": true,
      "El Ingeniero": true,
      "El Maestro": true,
      "El Molino": true,
      "El Obraje": true,
      "Jicaral": true,
      "La Colina": true,
      "La Laguna": true,
      "Las Flores": true,
      "Maraxcó": true,
      "Petapilla": true,
      "Planes De San Josè": true,
      "Sabana Grande": true,
      "San Esteban": true,
      "San Jorge": true,
      "Santa Elena": true,
      "Shusho Abajo": true,
      "Tierra Colorada": true,
      "Vado Hondo": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true
    },
    "San Jose la Arada": {
      "Chororogua": true,
      "Chororoguá": true,
      "El Rincon": true,
      "Los Cimientos": true,
      "San Jose La Arada": true,
      "Saspan": true,
      "Tierra Colorada": true,
      "Vega Arriba": true
    },
    "San Juan Ermita": {
      "La Ceibita": true,
      "Las Veguitas": true,
      "Los Planes": true,
      "San Juan Ermita": true,
      "Ticanlu": true
    },
    "Jocotan": {
      "El Florido": true,
      "Jocotan": true,
      "La Calavera": true,
      "Las Crucitas Jocotan": true,
      "Los Vados": true
    },
    "Camotan": {
      "Brasilar": true,
      "Camotan": true,
      "Caparja": true,
      "El Florido": true,
      "La Libertad": true,
      "La Rebalsa": true,
      "Pajco": true,
      "Shupa": true
    },
    "Olopa": {
      "Calera": true,
      "El Chucte": true,
      "Nochan": true,
      "Olopa": true,
      "Tituque": true
    },
    "Esquipulas": {
      "Atulapa": true,
      "Bueyeros": true,
      "Cafetales": true,
      "Chanmagua": true,
      "El Rodeo": true,
      "Frontera Agua Caliente": true,
      "Olopita": true,
      "Pinalito Jagua": true,
      "Santa Rosalía": true,
      "Tontoles": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "Concepcion las minas": {
      "Alambrados": true,
      "Aldea Apantes": true,
      "Anguiatu": true,
      "Conacaste": true,
      "Concepcion Las Minas": true,
      "Cruz Calle": true,
      "Dolores": true,
      "El Obraje": true,
      "El Rodeo": true,
      "Guacamayas": true,
      "La Ermita": true,
      "La Leona": true,
      "Los Limones": true,
      "Rodeito": true,
      "Rodeo El Espino": true,
      "San Antonio": true
    },
    "Quezaltepeque": {
      "Azacualpa": true,
      "El Recibimiento": true,
      "Encuentros Abajo": true,
      "Encuentros Arriba": true,
      "Guatalon": true,
      "Llano Grande": true,
      "Padre Miguel": true,
      "Piedras Azules": true,
      "Rio Grande": true,
      "Salfate": true,
      "Yocon": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "San Jacinto": {
      "Pastores": true,
      "San Jacinto": true,
      "San Jorge": true,
      "Tamarindo": true,
      "Ticanlú Abajo": true
    },
    "Ipala": {
      "Cececapa": true,
      "Dolores": true,
      "El Amatillo": true,
      "El Obraje": true,
      "El Sauce": true,
      "Ipala": true,
      "Jicamapa": true,
      "Posa De La Pila": true,
      "San Francisco": true,
      "San Isidro": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    }
  },
  "El Progreso": {
    "Guastatoya": {
      "Aldea Casas Viejas": true,
      "Aldea El Callejon": true,
      "Aldea El Subinal": true,
      "Aldea Las Morales": true,
      "Aldea Palo Amontonado": true,
      "Aldea Piedra Parada": true,
      "Aldea Santa Lucia": true,
      "Aldea Santa Rita": true,
      "El Naranjo": true,
      "La Libertad": true,
      "Tierra Blanca": true,
      "Zona 1": true,
      "Zona 2 - Guastatoya": true,
      "Zona 3": true,
      "Zona 4 Guastatoya": true,
      "Zona 5": true,
      "Zona 6": true
    },
    "Morazan": {
      "Agua Caliente": true,
      "Aristondos": true,
      "Buena Vista": true,
      "Casas Viejas, Guastatoya": true,
      "El Carrizo": true,
      "El Coyote": true,
      "El Moral": true,
      "El Zapote Morazán": true,
      "Los Leones": true,
      "Los Tablones": true,
      "Marajuma": true,
      "Morazan": true,
      "Plan De Las Flores": true,
      "San Diego": true,
      "San Miguel Buena Vista Morazán": true,
      "Santa Lucia": true
    },
    "San Agustin Acasaguastlan": {
      "El Rancho": true,
      "Las Champas El Rancho": true,
      "Pasasagua": true,
      "San Agustin Acasaguastlan": true,
      "Santa Gertrudis": true,
      "Tulumaje": true,
      "Tulumajillo": true
    },
    "San Cristobal Acasaguastlan": {
      "La Estancia De La Virgen": true,
      "Manzanal": true,
      "San Cristobal Acasaguastlan": true
    },
    "El Jicaro": {
      "El Jicaro": true,
      "El Jute": true,
      "Espiritu Santo": true,
      "Las Anonas": true,
      "Las Ovejas": true,
      "Llano De Jesus": true,
      "Lo De China": true,
      "Los Bordos": true,
      "Paso De Jalapas": true,
      "San Antonio Aguas Calientes": true,
      "Santa Cruz": true,
      "Santa Lucia Los Ocotes": true,
      "Santa Rosalía": true
    },
    "Sansare": {
      "La Montañita": true,
      "La Trinidad": true,
      "Las Cabezas": true,
      "Llano Grande": true,
      "Los Cerritos": true,
      "Poza Verde": true,
      "Rio Grande": true,
      "San Felipe La Tabla": true,
      "Sansare": true
    },
    "Sanarate": {
      "Agua Salobrega": true,
      "Aldea El Carrizo": true,
      "Aldea La Coyotera": true,
      "Aldea Monte Grande": true,
      "Aldea Santa Cruz": true,
      "Calzada CD San José": true,
      "El Amatillo": true,
      "El Cobano Saranate": true,
      "El Conacaste": true,
      "El Conacaston": true,
      "El Sinaca": true,
      "Jutiapilla": true,
      "Las Tunas": true,
      "Llanos De Morales": true,
      "Los Cerritos": true,
      "Montepeque": true,
      "Puente Platanos": true,
      "San Juan Las Flores": true,
      "Sansirisai": true,
      "Tierra Blanca": true,
      "Upayon": true,
      "Zona 1 - Sanarate": true,
      "Zona 2 - Sanarate": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true
    },
    "San Antonio La Paz": {
      "Agua Caliente": true,
      "Cucajol": true,
      "Dolores": true,
      "El Chile": true,
      "El Chorro": true,
      "El Hato": true,
      "Llano Largo": true,
      "Los Planes": true,
      "San Antonio La Paz": true,
      "Sansare": true,
      "Santo Domingo Los Ocotes": true
    }
  },
  "Escuintla": {
    "Escuintla": {
      "Aldea Las Chapernas": true,
      "Brito (Aldea)": true,
      "El Florido Aceituno": true,
      "El Recuerdo": true,
      "El Rodeo": true,
      "El Salto": true,
      "El Zapote": true,
      "Escuintla": true,
      "Finca Santo Tomas (Aqua Park)": true,
      "Ingenio Concepcion": true,
      "Ingenio Santa Ana": true,
      "Los Lirios, Escuintla, Guatemala": true,
      "San Antonio Buena Vista": true,
      "San Carlos Canada": true,
      "San Gabriel": true,
      "San Juan Mixtan": true,
      "San Luis Buena Vista": true,
      "Sidegua": true,
      "Vallarta": true,
      "Versalles": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "zona 1": true
    },
    "Santa Lucia Cotzumalguapa": {
      "Aldea El Rosario": true,
      "Buenos Aires": true,
      "Camantulul": true,
      "Canton Las Animas": true,
      "Cañaverales": true,
      "Cerro Colorado": true,
      "Chontel (Aldea)": true,
      "Colonia Maya": true,
      "El Baul": true,
      "El Socorro": true,
      "El Triunfo": true,
      "Ingenio La Union": true,
      "La Adelina": true,
      "Las Joyas": true,
      "Los Tarros": true,
      "Miriam 1 Y 2": true,
      "Parcelamiento El Cajon": true,
      "Rio Santiago": true,
      "San Pedrito": true,
      "Santa Lucia Cotzumalguapa": true,
      "Velasquito (Aldea)": true,
      "Vista Linda": true
    },
    "La Democracia": {
      "Ceiba Amelia": true,
      "El Arenal": true,
      "El Pilar (Aldea)": true,
      "Ingenio Magdalena": true,
      "La Democracia": true,
      "Velasquitos": true
    },
    "Siquinala": {
      "Siquinala": true
    },
    "Masagua": {
      "Cuyuta Masagua": true,
      "El Milagro Masagua": true,
      "Finca La Trinidad": true,
      "Las Guacas": true,
      "Masagua": true,
      "San Miguel Las Flores": true,
      "Santa Luisa (Aldea)": true
    },
    "Tiquisate": {
      "Almolonga": true,
      "Bolivia": true,
      "Huitzizil": true,
      "Jabali": true,
      "Los Barriles": true,
      "Parcelamiento El Arisco": true,
      "Pinula": true,
      "San Juan La Noria": true,
      "Santa Rosita": true,
      "Semillero": true,
      "Ticanlu (Aldea)": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "La Gomera": {
      "El Estero": true,
      "El Paredon": true,
      "El Terrero": true,
      "La Empalizada": true,
      "La Gomera": true,
      "Las Playas": true,
      "Las Pozas (Aldea)": true,
      "Los Chatos": true,
      "Parcelamiento El Silencio": true,
      "Parcelamiento Las Cruces": true,
      "San Jeronimo": true,
      "San Jose Nuevo Mundo": true,
      "Sipacate": true,
      "Texcuaco (Aldea)": true
    },
    "Guanagazapa": {
      "Guanagazapa": true,
      "Las Flores": true
    },
    "Puerto San Jose": {
      "Arizona": true,
      "Boton Blanco": true,
      "Cataras De Uxmel": true,
      "Chulamar": true,
      "El Campamento La Barrita": true,
      "El Carrizo": true,
      "El Naranjo": true,
      "Juan Gaviota": true,
      "La Barrita Vieja": true,
      "La Guardiania": true,
      "La Libertad": true,
      "La Virgen": true,
      "Las Pampas": true,
      "Linares": true,
      "Llanitos": true,
      "Malibu 1 Y 2": true,
      "Marinas Del Sur": true,
      "Obrero": true,
      "Parcelamiento Los Angeles": true,
      "Puerto Quetzal": true,
      "Puerto San Jose": true,
      "Puerto San José": true,
      "Quintas de Samayoa": true,
      "Rancho Siguacan": true,
      "Santa Isabel": true,
      "Torremolinos": true
    },
    "Iztapa": {
      "Blanca Cecilia": true,
      "Buena Vista": true,
      "Carrizo": true,
      "Conacaste": true,
      "El Astillero": true,
      "El Carrizal": true,
      "El Gariton": true,
      "El Guayabo (Aldea)": true,
      "El Moron": true,
      "El Pumpo (Aldea)": true,
      "Iztapa": true,
      "La Providencia": true,
      "Las Delicias": true,
      "Las Morenas": true,
      "Likin": true,
      "Puerta De Hierro": true,
      "Puerto Iztapa": true,
      "Puerto Viejo": true,
      "Wiscoyol (Parcelamiento)": true
    },
    "Palin": {
      "Palin": true
    },
    "San Vicente Pacaya": {
      "San Vicente Pacaya": true
    },
    "Nueva Concepcion": {
      "Centro 2": true,
      "El Chirivisco": true,
      "El Juxte": true,
      "El Novillero": true,
      "El Reparo": true,
      "El Semillero": true,
      "Estrellas Del Sur": true,
      "La Nueva Concepcion": true,
      "Las Flores": true,
      "Las Trochas": true,
      "Nueva Concepcion": true,
      "Nueva concepción Las Pampas": true,
      "Palo Blanco": true,
      "San Jose Mogollon": true,
      "Santa Ana Mixtan": true,
      "Santa Clara": true,
      "Tecojate": true,
      "Trocha Del Tigre": true
    }
  },
  "Guatemala": {
    "Guatemala": {
      "Arimani - zona 6": true,
      "Bosques De Villa Linda- zona 7": true,
      "Castillo Lara - zona 7": true,
      "Cayalá - zona 16": true,
      "Centro America - zona 7": true,
      "Ciudad Capital": true,
      "Colegio De Maestros - zona 17": true,
      "Colonia 4 De Febrero - zona 7": true,
      "Colonia Alvarado": true,
      "Colonia El Carmen - zona 12": true,
      "Colonia El Pino - zona 17": true,
      "Colonia Meyer - zona 17": true,
      "Colonia Toledo - zona 11": true,
      "Colonia Trinidad - zona 15": true,
      "Concepcion Las Lomas - zona 16": true,
      "Consulado Americano- zona 16": true,
      "El Carrizal": true,
      "El Rodeo - zona 7": true,
      "Finca Vista Hermosa - zona 17": true,
      "Internacional Caex Zona 12": true,
      "Jocotillo": true,
      "La Bethania - zona 7": true,
      "La Floresta - zona 7": true,
      "La Florida - zona 19": true,
      "La Verbena - zona 7": true,
      "Landivar - zona 7": true,
      "Las Charcas - zona 11": true,
      "Las Cumbres zona 16": true,
      "Las Fuentes - zona 16": true,
      "Las Vacas - zona 17": true,
      "Llano Largo - zona 18": true,
      "Lomas Del Norte - zona 17": true,
      "Lomas Del Rodeo - zona 7": true,
      "Los Rodriguitos - zona 18": true,
      "Lourdes - zona 16": true,
      "Mariscal - zona 11": true,
      "Montes Sano - zona 16": true,
      "Peñon De San Angel - zona 2": true,
      "Potrero Grande - Palencia": true,
      "Quinta Samayoa - zona 7": true,
      "Residenciales Del Norte - zona 18": true,
      "Residenciales San Fernando - zona 17": true,
      "Sabana Arriba - zona 17": true,
      "Salud Publica - zona 17": true,
      "San Gabriel - zona 2": true,
      "San Isidro - zona 16": true,
      "San Martin - zona 7": true,
      "Santa Amelia - zona 16": true,
      "Santa Luisa - zona 18": true,
      "Santa Marta 1, 2 Y 3": true,
      "Santa Rosita - zona 16": true,
      "Tecun Uman - zona 15": true,
      "Universidad Rafael Landivar - zona 16": true,
      "Utatlán - zona 7": true,
      "Utatlán 1 - zona 7": true,
      "Valle Verde - zona 7": true,
      "Villa Linda 3 y 1 - zona 7": true,
      "Villas De Cantabria - zona 16": true,
      "Villas De San Angel - zona 2": true,
      "Villas Del Norte - zona 17": true,
      "Zona 1": true,
      "Zona 10": true,
      "Zona 11": true,
      "Zona 12": true,
      "Zona 13": true,
      "Zona 14": true,
      "Zona 15": true,
      "Zona 16": true,
      "Zona 17": true,
      "Zona 18": true,
      "Zona 19": true,
      "Zona 2": true,
      "Zona 21": true,
      "Zona 25, Guatemala, Guatemala": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true,
      "Zona 8": true,
      "Zona 9": true
    },
    "Santa Catarina Pinula": {
      "Cristo Rey": true,
      "Don Justo": true,
      "El Carmen": true,
      "El Pajon": true,
      "El Prado": true,
      "El Rosario": true,
      "El Socorro": true,
      "Laguna Bermeja": true,
      "Manzano La Libertad": true,
      "Piedra Parada": true,
      "Puerta Parada": true,
      "San Jorge Muxbal": true,
      "San Jose El Manzano": true,
      "Santa Catarina": true,
      "Santa Catarina Pinula": true,
      "Sienaga Grande": true
    },
    "San Jose Pinula": {
      "Colorado": true,
      "Concepcion": true,
      "Lo De Contreras": true,
      "Puertas Negras": true,
      "Roosbelt": true,
      "San Jose Pinula": true,
      "San Luis": true,
      "Santa Rita": true
    },
    "San Jose Del Golfo": {
      "San Jose Del Golfo": true
    },
    "Palencia": {
      "Aldea Azacualpilla": true,
      "El Paraiso": true,
      "La Joya": true,
      "Los Mixcos Palencia": true,
      "Palencia": true,
      "Zona 24": true
    },
    "San Pedro Ayampuc": {
      "El Naranjo": true,
      "La Joya Del Ternero": true,
      "San Pedro Ayampuc": true
    },
    "Mixco": {
      "Aldea Lo De Fuentes": true,
      "Avances De Terramontes zona 11": true,
      "Balcones - zona 8": true,
      "Belen - zona 7": true,
      "Belensito - zona 7": true,
      "Bosques De San Nicolas - zona 4": true,
      "Bosques Del Mirador": true,
      "Campanero - zona 8": true,
      "Ciudad Satelite - zona 9": true,
      "Colonia 1 De Julio - zona 5": true,
      "Colonia 10 De Mayo": true,
      "Colonia Alvarado - zona 2": true,
      "Colonia Cotió - zona 3": true,
      "Colonia Pablo Sexto - zona 10": true,
      "El Encinal - zona 7": true,
      "El Milagro": true,
      "El Naranjo - zona 4": true,
      "El Rosario - zona 3": true,
      "El Sinaca": true,
      "Granjas - zona 8": true,
      "Juan Pablo - zona 10": true,
      "Juan Pablo - zona 7": true,
      "La Brigada - zona 7": true,
      "La Escuadrilla - zona 2": true,
      "Las Brisas - zona 6": true,
      "Mixco": true,
      "Mixco Norte - zona 6": true,
      "Molino De Las Flores - zona 2": true,
      "Monserrat - zona 4": true,
      "Monserrat 2 - zona 4": true,
      "Monte Verde - zona 4": true,
      "Monterreal - zona 4": true,
      "Panorama - zona 8": true,
      "Pequeña Tinco - zona 1": true,
      "Peronia": true,
      "Pinares - zona 8": true,
      "Residenciales Roosevelt  - zona 2": true,
      "Sacoj Chiquito": true,
      "Sacoj Grande": true,
      "San Ignacio - zona 10": true,
      "San Jacinto La Comunidad": true,
      "San Jorge Yumar - zona 6": true,
      "San Jose Los Pinos - zona 6": true,
      "Santa Marta - zona 5": true,
      "Terrazas - zona 8": true,
      "Tierra Nueva 1": true,
      "Villa Fernanda - zona 6": true,
      "Villa Flor - zona 6": true,
      "Villa Victoria - zona 6": true,
      "Villas Del Milagro - zona 6 de mixco": true,
      "Vistas Del Encinal - zona 6": true,
      "Zona 1": true,
      "Zona 10": true,
      "Zona 11": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true,
      "Zona 8": true,
      "Zona 9": true
    },
    "San Pedro Sacatepequez": {
      "Sajcabilla": true,
      "San Pedro Sacatepequez": true,
      "Vista Hermosa": true
    },
    "San Juan Sacatepequez": {
      "Aldea Cerro Alto": true,
      "Aldea Chitol": true,
      "Aldea Lo De Carranza": true,
      "Aldea Loma Alta": true,
      "Chuillany": true,
      "Ciudad Quetzal": true,
      "Colonia Trinidad": true,
      "Comunidad De Ruiz": true,
      "Comunidad De Zet": true,
      "Cruz Blanca": true,
      "Cruz Verde": true,
      "El Eden": true,
      "Las Vistas": true,
      "Llano De Las Flores": true,
      "Loma Alta": true,
      "Margaritas": true,
      "Monte Carmelo": true,
      "Pachali": true,
      "Recidenciales El Quetzal": true,
      "Sacsuy": true,
      "San Gabriel": true,
      "San Juan Sacatepequez": true,
      "San Juaneros 1 y 2": true,
      "Suacite": true,
      "Villa Verde": true,
      "Villas Del Quetzal": true,
      "Zona 3": true
    },
    "San Raymundo": {
      "Aldea Montufar": true,
      "El Cafetal": true,
      "Llano De La Virgen": true,
      "Los Cipreses": true,
      "Los Encinos": true,
      "Los Pajoques": true,
      "Mixco Viejo": true,
      "San Raymundo": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true
    },
    "Chuarrancho": {
      "Chuarrancho": true,
      "Estancia La Virgen": true,
      "Nacahuil": true
    },
    "Fraijanes": {
      "Arrazola": true,
      "Calle Olmeca": true,
      "El Cerrito": true,
      "El Chocolate": true,
      "El Platanar": true,
      "Fraijanes": true,
      "La Foresta": true,
      "Lo De Dieguez": true,
      "Los Verdes": true
    },
    "Amatitlan": {
      "Altos De La Cruz": true,
      "Amatitlan": true,
      "El Morlon": true,
      "El Pedregal": true,
      "El Tacaton": true,
      "San Vicente Pacaya": true
    },
    "Villa Nueva": {
      "Alamedas De San Miguel": true,
      "Alamedas De Santa Clara": true,
      "Altamira": true,
      "Altos De Barcenas": true,
      "Altos De San Jose": true,
      "Altos De Sonora": true,
      "Barcenas": true,
      "Bucaro": true,
      "Campo Real": true,
      "Cerro Alto": true,
      "Ciudad Del Sol": true,
      "Colinas Del Sur": true,
      "Colonia 30 De Octubre": true,
      "Colonia Castillo": true,
      "Colonia Cobinta": true,
      "Colonia El Maestro": true,
      "Colonia Ulices Rojas": true,
      "Colonia Venecia 1 y 2": true,
      "Condominio Las Piletas": true,
      "Condominio Santa Catalina": true,
      "Condominio Viñas Sur": true,
      "El Frutal": true,
      "Extencio Rio Platanitos": true,
      "Fuentes De San Jose 1,2 Y 3": true,
      "Guadalupe 1, 2 Y 3": true,
      "Guatel": true,
      "Inde 1 Y 2": true,
      "Jardines": true,
      "Jardines De La Virgen": true,
      "La Arada": true,
      "La Enrriqueta": true,
      "La Felicidad": true,
      "Linda Vista": true,
      "Llano Alto": true,
      "Lomas Del Sur": true,
      "Los Cerritos": true,
      "Los Flanes": true,
      "Los Tanques 1 Y 2 (Colonia Y Condominio)": true,
      "Maria Elena 1 Y 2": true,
      "Mesquital": true,
      "Metrocentro": true,
      "Monte Bello": true,
      "Naciones Unidas": true,
      "Panoramica Del Frutal": true,
      "Pinares Del Lago": true,
      "Planes De Barcenas": true,
      "Planes Del Frutal": true,
      "Prado Alto": true,
      "Prados": true,
      "Prados De San Jose": true,
      "Prados De Sonora": true,
      "Prados De Verona": true,
      "Primavera": true,
      "Ramirez": true,
      "Recidenciales Catalina": true,
      "Residencial La Encenada": true,
      "Residenciales El Prado": true,
      "Residenciales El Tabacal": true,
      "Residenciales Villa Lobos": true,
      "San Jose El Placer": true,
      "San Jose Villa Nueva": true,
      "San Luis": true,
      "San Mateo": true,
      "San Miguelito": true,
      "Santa Clara": true,
      "Santa Isabel 1 Y 2": true,
      "Santa Monica": true,
      "Solidarista": true,
      "Terranoba": true,
      "Valle Verde": true,
      "Valles De Maria": true,
      "Valles De Sonora 1,2,3,4,5": true,
      "Villa Lobos 1 Y 2": true,
      "Villa Nueva": true,
      "Villa Romana": true,
      "Villas De Doña Leonor": true,
      "Vista Al Valle": true,
      "Zona 1": true,
      "Zona 10": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true
    },
    "Villa Canales": {
      "Aldea El Canchon": true,
      "Beralminas": true,
      "Boca Del Monte": true,
      "Chichimecas": true,
      "Colmenas": true,
      "El Jocotillo": true,
      "El Porvenir": true,
      "La Concha": true,
      "La Cuchilla": true,
      "Los Dolores": true,
      "Los Llanos": true,
      "Los Pocitos": true,
      "Obrajuelo": true,
      "San Rafaelito": true,
      "Santa Elena Barillas": true,
      "Santa Inés Petapa": true,
      "Villa Canales": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 5": true
    },
    "San Miguel Petapa": {
      "San Miguel Petapa": true,
      "Villa Hermosa": true,
      "Zona 5": true
    },
    "Chinautla": {
      "Chinautla": true,
      "Santa Cruz Chinautla": true
    }
  },
  "Huehuetenango": {
    "Huehuetenango": {
      "Chimusinique": true,
      "Chinaca": true,
      "Chiquival": true,
      "El Carrizal": true,
      "Huehuetenango": true,
      "San Lorenzo": true,
      "Tocojaz": true,
      "Zona 1": true,
      "Zona 10": true,
      "Zona 11": true,
      "Zona 12": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true,
      "Zona 8": true,
      "Zona 9": true
    },
    "Aguacatan": {
      "Agua Blanca": true,
      "Agua Blanca I": true,
      "Agua Blanca Ii": true,
      "Buena Vista": true,
      "Calin": true,
      "Chex": true,
      "Chichuj": true,
      "Chuikankab": true,
      "Cuesta Chiquita": true,
      "El Barranca": true,
      "El Cancho": true,
      "El Cipresal": true,
      "El Limonar": true,
      "El Rosario": true,
      "El Salvador": true,
      "El Tichon": true,
      "Irchimal": true,
      "Ixcoloy": true,
      "La Esperancita": true,
      "La Labor": true,
      "La Laguna I": true,
      "La Laguna Ii": true,
      "Las Pilas": true,
      "Llano Chiquito": true,
      "Los Cipresales": true,
      "Petzal": true,
      "Potrerillo": true,
      "Pueblo Viejo": true,
      "Quilen Novillo": true,
      "Quilintoro": true,
      "Rio Blanco": true,
      "Rio Blanco Chiquito": true,
      "Rio Negro": true,
      "Rio Seco": true,
      "Seco": true,
      "Tichon": true,
      "Tierra Blanca": true,
      "Tres Cruces": true,
      "Tucuna": true,
      "Xetnum": true,
      "Xilamaton": true,
      "Xolpic": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Chiantla": {
      "Buenos Aires": true,
      "Chancol": true,
      "Chochal": true,
      "Chuscaj": true,
      "Chuxcaj": true,
      "El Carpintero": true,
      "El Manzanillo": true,
      "El Pino": true,
      "El Rancho": true,
      "El Rosario": true,
      "Ixquiac": true,
      "La Alfalfa": true,
      "La Capellania": true,
      "La Labor": true,
      "La Lagunita": true,
      "La Quebradita": true,
      "Las Guayabitas": true,
      "Las Manzanas": true,
      "Mixlaj": true,
      "Palo Grande": true,
      "Paquix": true,
      "Patio De Bolas": true,
      "Potrerillo": true,
      "Quilinco": true,
      "Regadillos": true,
      "Rio Escondido": true,
      "San Antonio Las Nubes": true,
      "San Francisco Las Flores": true,
      "San Jose Las Flores": true,
      "San Nicolas": true,
      "Sibila": true,
      "Taluca": true,
      "Torlon": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "Colotenango": {
      "Bella Vista": true,
      "Colotenango": true,
      "El Granadillo": true,
      "Ical": true,
      "Ixconlaj": true,
      "La Barranca": true,
      "La Vega": true,
      "Tixel": true,
      "Tojlate": true,
      "Xemal": true
    },
    "Concepcion Huista": {
      "Ajul": true,
      "Ap": true,
      "Bacu": true,
      "Chalhuitz": true,
      "Concepcion Huista": true,
      "Onlaj": true,
      "Secheu": true,
      "Tzujuan": true,
      "Yatolop": true
    },
    "Cuilco": {
      "Agua Dulce": true,
      "Agua Sembrada": true,
      "Batal": true,
      "Cancuc": true,
      "Canibal": true,
      "Checuj": true,
      "Chejoj": true,
      "Chiquihuil": true,
      "Concepcion Posonicapa Chiquito": true,
      "Corinto": true,
      "Cruz Chapala": true,
      "Cua": true,
      "Cuilco": true,
      "El Chilcal": true,
      "El Herrador": true,
      "El Monumento": true,
      "El Retiro": true,
      "El Rodeo": true,
      "El Rosario": true,
      "El Sabino": true,
      "El Tablon": true,
      "El Triunfo": true,
      "El Zapote": true,
      "El Zapotillo": true,
      "Guachipilin": true,
      "Haciendita Las Flores": true,
      "Hoja Blanca": true,
      "Horno De Cal": true,
      "Islan": true,
      "Ixlan": true,
      "Ixmulej": true,
      "Jovi": true,
      "Oaxaqueño": true,
      "Pajonada": true,
      "Pojonada Alta": true,
      "Posonicapa": true,
      "Posonicapa Grande": true,
      "Queva": true,
      "Rodeo": true,
      "Sabunul": true,
      "Santa Rosa": true,
      "Santa Rosa Canibal": true,
      "Shequenibaj": true,
      "Sosi": true,
      "Sotzi": true,
      "Tuya": true,
      "Vuelta Grande": true,
      "Yerba Buena": true,
      "Yulva": true
    },
    "Jacaltenango": {
      "Bujxup": true,
      "Catarina": true,
      "Chapaltelaj": true,
      "Chejbal": true,
      "Cheya": true,
      "Com": true,
      "El Limonar": true,
      "Emul": true,
      "Huistan": true,
      "Huitzjobal": true,
      "Huixac": true,
      "Inchehuex": true,
      "Junglina": true,
      "La Laguna": true,
      "Meste": true,
      "Nueva Catarina": true,
      "Pebil Pam O Yusioma": true,
      "San Andres Huista": true,
      "San Marcos Huista": true,
      "Tajbujxub": true,
      "Tzisbaj": true,
      "Xacaltenango": true,
      "Xoyomlaj": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "La Democracia": {
      "Buenos Aires Huixoc": true,
      "Camoja Grande": true,
      "Camojaito": true,
      "Chamuxu": true,
      "El Carrizo": true,
      "El Coyegual": true,
      "El Mamonal": true,
      "La Mesilla": true,
      "La Nueva Esperanza": true,
      "La Reforma Chojil": true,
      "Los Tarayes": true,
      "Pontzaj": true,
      "San Isidro": true,
      "San Jose O Ixcunen": true,
      "Santa Rosa": true,
      "Valparaiso": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "La Libertad": {
      "Aguacate": true,
      "Cerro Grande": true,
      "El Amapolar": true,
      "El Bojonal": true,
      "El Ceciliar": true,
      "El Cenegal": true,
      "El Chalum": true,
      "El Chicharro": true,
      "El Jute": true,
      "El Limar": true,
      "El Naranjo": true,
      "El Paraiso": true,
      "El Rodeo": true,
      "El Sauce": true,
      "El Trapichillo": true,
      "La Libertad": true,
      "La Montaña": true,
      "Palmira Nueva": true,
      "Palmira Vieja": true,
      "Peña Roja": true,
      "San Felipe La Montaña": true,
      "San Ramon La Montaña": true,
      "Santo Domingo Huica": true,
      "Santo Domingo Las Flores": true
    },
    "Malacatancito": {
      "Cacum": true,
      "Cancabal": true,
      "Chiaque": true,
      "Chocal": true,
      "Cieneguillas": true,
      "Concepcion La Cal": true,
      "Cucal": true,
      "Mala": true,
      "Piache": true,
      "Pucal": true,
      "Pueblo Viejo": true,
      "Quiaquisuyal": true,
      "Rio Hondo": true,
      "San Ramon": true,
      "Xepon": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true
    },
    "Nenton": {
      "Aguacate": true,
      "Cajatavi": true,
      "Canquintic": true,
      "Chacaj": true,
      "Chanquejelbe": true,
      "Chaquial": true,
      "El Aguacate": true,
      "El Limon": true,
      "Gracias A Dios": true,
      "Jom": true,
      "La Fortuna": true,
      "La Laguna Chaquial": true,
      "Nenton": true,
      "Nueva Concepcion": true,
      "Nueva Fortuna": true,
      "Ojo De Agua Lagarto": true,
      "Pocobastic I": true,
      "Quixal": true,
      "Salamay": true,
      "Santa Rosa Buena Vista": true,
      "Santa Teresa": true,
      "Subajasum": true,
      "Tzojbal": true,
      "Xoxtac": true,
      "Yalambojoch": true,
      "Yalisau": true,
      "Yuxquen": true
    },
    "San Antonio Huista": {
      "El Coyegual": true,
      "El Pajal": true,
      "Nojoya": true,
      "Rancho Viejo": true,
      "San Antonio Huista": true,
      "San Jose El Tablon": true
    },
    "San Gaspar Ixchil": {
      "Buena Vista": true,
      "Coxton": true,
      "Manaja": true,
      "San Gaspar Ixchil": true
    },
    "Ixtahuacan": {
      "Acal": true,
      "Casaca": true,
      "Chiquilila": true,
      "El Granadillo": true,
      "El Papal": true,
      "La Cumbre": true,
      "San Ildefonso Ixtahuacan": true,
      "Vega Poloja": true,
      "Vega San Miguel": true
    },
    "San Juan Atitan": {
      "Camul": true,
      "Checoche": true,
      "Cojton": true,
      "Cuate": true,
      "San Juan Atitan": true,
      "Santa Barbara": true,
      "Santa Isabel": true,
      "Tuiscap": true
    },
    "San Juan Ixcoy": {
      "Bacu": true,
      "Canchicu": true,
      "Candelaria Chitamil Fixap": true,
      "Chanchocal I": true,
      "Chanchocal Ii": true,
      "Chelbal": true,
      "Chemal": true,
      "Chitamil": true,
      "Jolomhuitz": true,
      "Jolotes": true,
      "La Brisa": true,
      "Mixla O Yajamcup": true,
      "Ocheval": true,
      "Pie De La Cuesta": true,
      "Quisil": true,
      "Sachan": true,
      "San Juan Ixcoy": true,
      "Signub": true,
      "Tixap": true,
      "Tocal": true,
      "Tojquia": true,
      "Xopacal": true,
      "Yajaucu": true,
      "Yaxeu": true,
      "Yulchecan": true,
      "Yulhuitz": true
    },
    "San Mateo Ixtatan": {
      "Bulej": true,
      "Chexjoj": true,
      "Guaisna": true,
      "Ixpajau": true,
      "Jolomtenam": true,
      "Ocante": true,
      "Pacumal": true,
      "Patalcal": true,
      "Rio Seco": true,
      "San Mateo Ixtatan": true,
      "Yaca": true,
      "Yilcultac": true
    },
    "San Miguel Acatan": {
      "Akal Coya": true,
      "Canicham": true,
      "Canul": true,
      "Canuleu": true,
      "Cheche": true,
      "Chemalito": true,
      "Chempech": true,
      "Chenicham": true,
      "Chenicham Ii": true,
      "Chimban": true,
      "Copa": true,
      "Cotzancanalaj": true,
      "Coya": true,
      "Elmul": true,
      "Incop": true,
      "Ixchoch Sostelaj": true,
      "Ixlahuitx": true,
      "Ixpajau": true,
      "Ojo De Agua Napta": true,
      "Pacalaj": true,
      "Paiconop Chiquito": true,
      "Paiconop Grande": true,
      "Paycano": true,
      "Poza": true,
      "Sajchen": true,
      "San Miguel Acatan": true,
      "Suntelaj": true,
      "Taquina": true,
      "Ticajo": true,
      "Tiquisislaj": true,
      "Xocol": true,
      "Yalaj": true
    },
    "San Pedro Necta": {
      "Agua De Las Palomas": true,
      "Agua Dulce": true,
      "Ajal": true,
      "Buena Vista.": true,
      "Canoguitas": true,
      "Chejoj": true,
      "Chichimes": true,
      "Chimiche": true,
      "Chinacual": true,
      "El Palmar": true,
      "El Tzalay": true,
      "Guachipilin": true,
      "Huixoc": true,
      "Isnul": true,
      "Ixban": true,
      "La Laguna": true,
      "Los Alisos": true,
      "Los Coles": true,
      "Michicoy": true,
      "Nilla": true,
      "Nima": true,
      "Rio Ocho": true,
      "San Pedro Necta": true,
      "Siete Cerros.": true
    },
    "San Pedro Soloma": {
      "Bacau": true,
      "Buena Vista La Esperanza": true,
      "Cajpujpuja": true,
      "Cantel": true,
      "Cheval": true,
      "Chibal": true,
      "Chival": true,
      "Chivalcoj": true,
      "Chochcab": true,
      "Chono": true,
      "Gelna": true,
      "Gema": true,
      "Islichecan": true,
      "Isnanconob": true,
      "Ixlahuitz": true,
      "Ixtiapoc": true,
      "Ixtichacan": true,
      "Ixtichecam": true,
      "Ixtiquix": true,
      "Jolomar": true,
      "Jolomcu": true,
      "Jolomtenam": true,
      "Majcha": true,
      "Najap": true,
      "Pajaltac": true,
      "Poquin": true,
      "Pueblo Nuevo": true,
      "San Francisco": true,
      "San Pedro Soloma": true,
      "Suyil": true,
      "Yacxap": true,
      "Yaxac": true,
      "Yaxanlac": true,
      "Yincu": true,
      "Yinxul": true,
      "Yula": true,
      "Yulatiquir": true,
      "Yulichal": true
    },
    "San Rafael La Independencia": {
      "Achi": true,
      "Canmox": true,
      "Cantetaj": true,
      "Cololaj": true,
      "Inconob": true,
      "Incu": true,
      "Isticultaj": true,
      "Ixcama": true,
      "Ixcanac I": true,
      "Ixcanac Ii": true,
      "Ixcanap": true,
      "Ixtinajap": true,
      "Lajcholaj": true,
      "Los Molinos": true,
      "Patzlaj": true,
      "Pucpala": true,
      "San Rafael La Independencia": true,
      "Solomcu": true,
      "Sticultaj": true,
      "Stinajap": true,
      "Tataj": true,
      "Tinajap": true,
      "Toyajax": true,
      "Villa Linda": true,
      "Yula Ontetaj": true,
      "Yulaja": true,
      "Yulchen": true
    },
    "San Rafael Petzal": {
      "Caserio Rio San Juan": true,
      "Onatorio Alto": true,
      "San Rafael Petzal": true,
      "Santa Isabel": true,
      "Tuishaina": true,
      "Xechul": true
    },
    "San Sebastian Huehuetenango": {
      "Chejoj": true,
      "Chelam": true,
      "Chequequix": true,
      "Chexap Centro": true,
      "Chexap I": true,
      "Palajuchuj": true,
      "Piol": true,
      "Pueblo Viejo": true,
      "Quiajola": true,
      "San Sebastian": true,
      "Tzabal": true
    },
    "Santa Ana Huista": {
      "Agua Escondida": true,
      "Agua Zarca": true,
      "Buena Vista": true,
      "Buenos Aires": true,
      "Cuatro Caminos": true,
      "El Anonal La Montaña": true,
      "El Mojon": true,
      "El Tabacal": true,
      "El Terrero Pinalito": true,
      "Monajil": true,
      "Ojo De Agua La Montaña": true,
      "Santa Ana Huista": true,
      "Yuxen": true
    },
    "Santa Barbara": {
      "Chicol": true,
      "Cruz Quemada": true,
      "Sacpic": true,
      "Santa Barbara Huehuetenango": true,
      "Tojcail": true,
      "Tojchiquel": true,
      "Xoconilaj": true
    },
    "Santa Cruz Barillas": {
      "Agua Alegre": true,
      "Agua Caliente": true,
      "Altamira": true,
      "Amelco": true,
      "Balli": true,
      "Becana": true,
      "Buenos Aires Chiblac": true,
      "Centinela Grande": true,
      "Centro Dos": true,
      "Centro Jolomita": true,
      "Centro Tres": true,
      "Centro Uno": true,
      "Chipoxlac": true,
      "Concepcion": true,
      "Cuchumatán nuevo": true,
      "El Corozo": true,
      "El Jordan": true,
      "El Monaco": true,
      "Frontera 10 De Mayo": true,
      "Ixtateco La Paz Los Achiotes": true,
      "Jolomquem": true,
      "La Campana 1": true,
      "La Campana Ii": true,
      "La Felicidad Yulaxac": true,
      "La Florida": true,
      "La Palestina": true,
      "La Soledad": true,
      "Las Conchitas": true,
      "Malacatán nuevo": true,
      "Mayaland": true,
      "Momonlac": true,
      "Montenegro": true,
      "Nubila": true,
      "Nuca": true,
      "Nueva Generacion Maya": true,
      "Nueva Union Maya": true,
      "Nuevo Sija Santo Domingo": true,
      "Ojo De Agua Chancolin": true,
      "Ojo De Agua San Ramon": true,
      "Piedras Blancas": true,
      "Puente Alto": true,
      "Quetzal": true,
      "Rio Negro": true,
      "Sacchen": true,
      "San Antonio": true,
      "San Juan Tutlac": true,
      "San Ramon": true,
      "Tres Ranchos": true,
      "Xoxlac": true,
      "Yulatizu": true,
      "Yulconop": true,
      "Zona 1": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true
    },
    "Santa Eulalia": {
      "Amelco": true,
      "Asil": true,
      "B'Ololaq": true,
      "Cansacaj": true,
      "Ceiba": true,
      "Chibal Chiquito": true,
      "Chibal Grande": true,
      "Chojzunil": true,
      "Cocola Chiquito": true,
      "Cocola Grande": true,
      "Istenam": true,
      "Ixilte": true,
      "Ixtenam": true,
      "Mocuy Chiquito": true,
      "Mocuy Grande": true,
      "Molna": true,
      "Morelia": true,
      "Nancultac": true,
      "Paiconop": true,
      "Pananchilac": true,
      "Poila Azil": true,
      "Quixabaj": true,
      "San Luis": true,
      "Santa Alicia": true,
      "Santa Eulalia": true,
      "Temosh Grande": true,
      "Temush Yulas": true,
      "Tziquina Chiquito": true,
      "Tziquina Grande": true,
      "Valle Azul": true,
      "Xaxcacao": true,
      "Yalba": true,
      "Yaxcalante": true,
      "Yichom": true,
      "Yoch Pett": true
    },
    "Santiago Chimaltenango": {
      "Bella Vista": true,
      "La Florida": true,
      "Loma Grande": true,
      "Santiago Chimaltenango": true
    },
    "Todos Santos Cuchumatanes": {
      "Chalhuitz Los Perez": true,
      "Chemal": true,
      "Chiabal": true,
      "Chicoy": true,
      "El Rancho": true,
      "Mash": true,
      "San Martin": true,
      "Todos Santos Cuchumatan": true,
      "Tojumuc": true,
      "Xolhuitz": true
    },
    "Tectitan": {
      "Tectitan": true
    },
    "San Idelfonso Ixtaguacan": {
      "San Idelfonso Ixtaguacan": true
    },
    "San Sebastian Coatan": {
      "Biltac": true,
      "Bolontaj": true,
      "Cajbaquil": true,
      "Calhuitz": true,
      "Hiss": true,
      "Ixquebaj": true,
      "Ixtenam": true,
      "Jolomtenam": true,
      "Jucup": true,
      "Lolbatzam": true,
      "Poy": true,
      "Quejna": true,
      "Quiclum": true,
      "Quiquilum": true,
      "San Jose Pueblo Nuevo Jucup": true,
      "San Sebastian Coatan": true,
      "Santo Domingo Xeen": true,
      "Tiajaila": true,
      "Timacap": true,
      "Tzununcap": true,
      "Ucachoj": true,
      "Ulna": true,
      "Xoncol Timacte": true,
      "Yichioqueabaj": true,
      "Yichucum": true,
      "Yobixton": true,
      "Yolaquisis": true,
      "Yolaxito": true,
      "Yolhuitzon Tzula": true,
      "Yolxacla": true,
      "Yoxacla Tiquen": true
    },
    "Union Cantinil": {
      "Tiboch": true,
      "Union Cantinil": true
    },
    "Petatán": {
      "Cabic": true,
      "La Esperanza": true,
      "Limares": true,
      "Petatan": true
    }
  },
  "Izabal": {
    "Puerto Barrios": {
      "Alde Crik Negro": true,
      "Aldea Agua Caliente": true,
      "Barrio El Cangrejal": true,
      "Barrio El Limonar": true,
      "Barrio Las Champas": true,
      "Campo Verde I (Finca)": true,
      "Campo Verde Ii (Finca)": true,
      "Canarias": true,
      "Champona": true,
      "Chinoc": true,
      "Cimarron (Aldea)": true,
      "Colinas I Y Ii": true,
      "Colonia 15 De Abril": true,
      "Colonia Banvi I": true,
      "Colonia Banvi Ii": true,
      "Colonia Buena Vista": true,
      "Colonia Buenos Aires": true,
      "Colonia Colinas I": true,
      "Colonia Colinas Ii": true,
      "Colonia Coviemport": true,
      "Colonia El Cafetalito": true,
      "Colonia El Manantial": true,
      "Colonia El Tamarindal": true,
      "Colonia La Fuerteza": true,
      "Colonia La Repegua": true,
      "Colonia Las Flores": true,
      "Colonia Las Palmeras": true,
      "Colonia Los Gringos": true,
      "Colonia Los Pocitos": true,
      "Colonia Maria Luisa I": true,
      "Colonia Maria Luisa Ii": true,
      "Colonia Maria Luisa Iii": true,
      "Colonia Motocross": true,
      "Colonia Piedras Negras": true,
      "Colonia Portuaria": true,
      "Colonia Progreso": true,
      "Colonia San Manuel Hasta Colonia Maria Luisa": true,
      "Colonia Vista Hermosa": true,
      "Dos Puertos (Residenciales)": true,
      "Dublin (Finca)": true,
      "El Cinchado": true,
      "El Inde": true,
      "El Mitch": true,
      "El Pueblito": true,
      "Entre Rios": true,
      "Eskimo (Finca)": true,
      "Hopay (Finca)": true,
      "Jimeritos": true,
      "Kickappo (Finca)": true,
      "Las Escobas": true,
      "Limones": true,
      "Machacas": true,
      "Omagua III (Finca)": true,
      "Omagua Ii (Finca)": true,
      "Petromaya": true,
      "Piedra Parada": true,
      "Placa I": true,
      "Puerto Barrios": true,
      "Quebrada Seca": true,
      "San Agustin": true,
      "San Agustín": true,
      "San Andres": true,
      "San Francisco": true,
      "San Manuel": true,
      "Santo Tomas De Castilla": true,
      "Tenedores": true,
      "Villa Canales": true,
      "Vista Hermosa (Colonia)": true
    },
    "Livingston Carretera (CA13)": {
      "Aldea Seja": true,
      "Buena Vista": true,
      "Buenos Aires": true,
      "Chocon": true,
      "La Libertad": true,
      "Paracaidista": true,
      "Puerto Cadenas": true,
      "Rio Dulce": true,
      "San Felipe": true,
      "Semox": true,
      "Toquela": true
    },
    "El Estor": {
      "Compañia Minera": true,
      "El Estor": true,
      "El Murcielago": true,
      "El Paraiso": true,
      "La Coroza El Estor": true,
      "La Ensenada": true,
      "Sumach": true
    },
    "Morales": {
      "Alde El Boqueron": true,
      "Aldea Chane": true,
      "Aldea El Cerrito": true,
      "Aldea Guaytan": true,
      "Aldea Seux": true,
      "Aldea Sinai": true,
      "Aldea York": true,
      "Arapahoe": true,
      "Bananera": true,
      "Barranca Bananera": true,
      "Barrio Naranjo": true,
      "Buena Vista": true,
      "Buenos Aires": true,
      "Cadenas": true,
      "Cayuga": true,
      "Cedrito": true,
      "Cerritos": true,
      "Chiriqui": true,
      "Creek Zarco": true,
      "Cumbre El Rosario": true,
      "Darmouth": true,
      "El Benque El Amatillo": true,
      "El Cedro": true,
      "El Choco": true,
      "El Rosario": true,
      "Gran Cañon": true,
      "Juyama": true,
      "La  Libertad": true,
      "La Cienega": true,
      "La Colosa": true,
      "La Coroza": true,
      "La Libertad": true,
      "La Pimienta": true,
      "La Ruidosa": true,
      "Las Cruces": true,
      "Las Flores": true,
      "Las Posas": true,
      "Los Andes": true,
      "Los Angeles": true,
      "Mariscos": true,
      "Milla 45": true,
      "Milla 6": true,
      "Milla 7": true,
      "Montufar": true,
      "Morales": true,
      "Navajoa": true,
      "Nueva Esperanza": true,
      "Oneida": true,
      "Picuatz": true,
      "Piedras De Sangre": true,
      "Playitas": true,
      "Quebrada Grande": true,
      "Rio Blanco": true,
      "San Isidro El Choco": true,
      "San Rafael": true,
      "San Rafael El Choco": true,
      "Satelite": true,
      "Shane (aldea)": true,
      "Suiche Quebradas": true,
      "Valle Nuevo": true,
      "Virginia": true
    },
    "Los Amates": {
      "Aldea Patzun": true,
      "Aztec": true,
      "Campo II": true,
      "Campo III": true,
      "Chapulco": true,
      "Chapulquito": true,
      "Choctaw": true,
      "Cocales": true,
      "Colonia Nueva Jerusalen": true,
      "Colonia Santa Isabel": true,
      "Colonia Seminola": true,
      "Cristina": true,
      "Cruce De Las Ruinas": true,
      "Curva El Pino": true,
      "Dakota": true,
      "El Guacamayo": true,
      "El Jute": true,
      "El Polvorin": true,
      "El Quiche": true,
      "El Rico": true,
      "El Tipon": true,
      "Finca Campos Nuevos": true,
      "Finca Creek": true,
      "Finca El Pilar": true,
      "Finca Maya": true,
      "Finca Nueva": true,
      "Izabalito": true,
      "Juan De Paz": true,
      "La Ceiba": true,
      "La Democracia": true,
      "La Loma, Rio Blanco": true,
      "La Palmilla": true,
      "La Palmilla Vega Grande": true,
      "La Union": true,
      "Las Basas": true,
      "Las Viñas": true,
      "Loma del Rico": true,
      "Los Amates": true,
      "Madre Vieja": true,
      "Nahuá": true,
      "Natalia": true,
      "Planes De Quirigua": true,
      "Playa Dorada": true,
      "Puebla": true,
      "Puebla II": true,
      "Quirigua": true,
      "Rio Blanco": true,
      "Seminola": true,
      "Suiche Molina": true,
      "Trincheras": true,
      "Yaqui": true,
      "Yuma": true
    },
    "Livingston Isla (La Buga)": {
      "Barrio La Pista": true,
      "Barrio San Jose 1 y 2": true,
      "La Capitania": true,
      "Livingston La Buga": true,
      "Marco Sanchez Días": true,
      "Nuevo Creek Chino": true
    }
  },
  "Jalapa": {
    "Jalapa": {
      "Achiotes Jumay": true,
      "Carrizal": true,
      "Chagüite": true,
      "El Divisadero": true,
      "El Durazno": true,
      "El Paraiso": true,
      "Jalapa": true,
      "La Fuente": true,
      "La Laguneta": true,
      "La Paz": true,
      "La Toma": true,
      "Las Brisas": true,
      "Los Izotes": true,
      "Los Limares": true,
      "Los Lopez": true,
      "Palo verde": true,
      "San Francisco": true,
      "Sanpaquisoy": true,
      "Sansayo": true,
      "Sanyuyo": true,
      "Sashico": true,
      "Tatasirire": true,
      "Yerbabuena": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true
    },
    "San Pedro Pinula": {
      "Agua Zarca": true,
      "El Cuajilote": true,
      "El Maestrillo": true,
      "El Paso de los Riscos": true,
      "El Pinalon": true,
      "El Potreron": true,
      "El Zapote": true,
      "El Zunzo": true,
      "La Cumbre": true,
      "Los Chorros": true,
      "Pinalito": true,
      "San Marcos El Aguacate": true,
      "San Pedro Pinula": true,
      "Sansayo": true,
      "Santo Domingo": true
    },
    "San Luis Jilotepeque": {
      "Cruz De Villeda": true,
      "Culima": true,
      "Cushapa": true,
      "El Campo": true,
      "Palo Blanco": true,
      "Pampacaya": true,
      "San Luis Jilotepeque": true,
      "Songotongo": true,
      "Tierra Blanca": true
    },
    "San Manuel Chaparron": {
      "Damian (Aldea)": true,
      "El Rodeito": true,
      "Juan Cano": true,
      "La Peña (Aldea)": true,
      "Llano Verde": true,
      "Los Amates": true,
      "Poza Verde": true,
      "San Manuel Chaparron": true,
      "San Sebastian": true,
      "Vivares": true
    },
    "San Carlos Alzatate": {
      "El Pino Zapoton": true,
      "Garay": true,
      "Las Flores": true,
      "Las Tapias": true,
      "Miraflores": true,
      "Sabaneta": true,
      "San Carlos Alzatate": true
    },
    "Monjas": {
      "Buena Vista Achiotes": true,
      "Casa De Tablas": true,
      "El Copalar": true,
      "El Rodeo": true,
      "El Salamo": true,
      "La Campana": true,
      "La Recta": true,
      "Las Palmas (Aldea)": true,
      "Llano Grande": true,
      "Los Achiotes": true,
      "Mojarritas": true,
      "Monjas": true,
      "Morazan": true,
      "Ovejero": true,
      "Pinos Altos": true,
      "San Antonio": true,
      "San Juancito": true,
      "Terrones": true
    },
    "Mataquescuintla": {
      "La Pedrera": true,
      "Miramundo": true,
      "Morales": true,
      "Pino Dulce": true,
      "San José La Sierra": true,
      "Soledad Grande": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    }
  },
  "Jutiapa": {
    "Jutiapa": {
      "Aldea El Botadero": true,
      "Amayito": true,
      "Amayo Ingenio": true,
      "Amayo Sitio": true,
      "Canoas": true,
      "Caserio El Matilisguate": true,
      "Cerro Gordo": true,
      "Cieneguilla": true,
      "El Aguacate": true,
      "El Anonito": true,
      "El Barreal": true,
      "El Carrizal": true,
      "El Caulote": true,
      "El Chiltepe": true,
      "El Durazno": true,
      "El Naranjo": true,
      "El Pino": true,
      "El Rinconsito": true,
      "El Tablon": true,
      "Guacamayas": true,
      "Ixtacapa": true,
      "Jicaro Grande": true,
      "La Arada": true,
      "La Brea": true,
      "La Flor": true,
      "La Mina": true,
      "La Pajarita": true,
      "La Perla": true,
      "Las Crucitas": true,
      "Las Impresiones": true,
      "Las Majadas": true,
      "Las Mesas": true,
      "Las Pozas": true,
      "Las Tunas": true,
      "Los Anonos": true,
      "Maria Montaña": true,
      "Paso Bueno": true,
      "Piedra Blanca": true,
      "Pipilteque": true,
      "Potrero Grande": true,
      "Quebrada Seca": true,
      "Rio De La Virgen": true,
      "San Antonio": true,
      "Santa Clara": true,
      "Trancas 1": true,
      "Trancas 2": true,
      "Zamororo": true,
      "Zona 1 Jutiapa": true,
      "Zona 2": true,
      "Zona 3 Jutiapa": true,
      "Zona 4": true
    },
    "El Progreso": {
      "El Limon": true,
      "El Ovejero": true,
      "El Parcelamiento": true,
      "El Pino": true,
      "El Porvenir": true,
      "El Progreso, Achuapa": true,
      "El Rodeo": true,
      "Encino Gacho": true,
      "La Acequia": true,
      "La Vega": true,
      "Las Flores": true,
      "Las Uvas": true,
      "Los Apantes": true,
      "Moran Abajo": true,
      "Moran Arriba": true,
      "Pozas de Agua": true,
      "Valle Abajo": true,
      "Valle Arriba": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Santa Catarina Mita": {
      "Cuesta De Garcia": true,
      "Cuesta Del Guayabo": true,
      "El Puente": true,
      "El Quebracho": true,
      "El Rodeo": true,
      "Horcones": true,
      "Jocote Dulce": true,
      "La Barranca": true,
      "La Nueva": true,
      "La Union": true,
      "Las Lajas": true,
      "Las Pozas, Catocha": true,
      "Llano De Chinchilla": true,
      "Los Horcones": true,
      "Magueyes": true,
      "Poza Verde": true,
      "Santa Catarina Mita": true,
      "Santa Rosa": true,
      "Suchitan": true,
      "Vivares": true
    },
    "Agua Blanca": {
      "Agua Blanca": true,
      "El Carrizo": true,
      "El Quequexque": true,
      "El Tempisque": true,
      "El Tobon": true,
      "La Cima": true,
      "La Estacion": true,
      "Obrajuelo": true,
      "Panalvia": true,
      "Papalhuapa": true,
      "Piñuelas": true,
      "San Patricio": true
    },
    "Asuncion Mita": {
      "Achuapa": true,
      "Asuncion Grande": true,
      "Asuncion Mita": true,
      "Asuncioncita": true,
      "Buenos Aires": true,
      "Cerro Blanco": true,
      "Chavarria": true,
      "Cola De Pava": true,
      "Crucitas": true,
      "El Cipres": true,
      "El Guapinol": true,
      "El Jicaral": true,
      "El Manguito, Asunción Mita": true,
      "El Pito": true,
      "El Sitio de las Flores": true,
      "El Tamarindo": true,
      "El Tule": true,
      "Estanzuelas": true,
      "Frontera Anguiatu": true,
      "Girones": true,
      "Guevara": true,
      "La Arenera": true,
      "La Playa": true,
      "Laguna de Güija": true,
      "Las Moritas": true,
      "Loma Larga": true,
      "Los Amates": true,
      "Nueva Estanzuelas": true,
      "San Joaquin": true,
      "San Jose Las Flores": true,
      "San Juan Las Minas": true,
      "San Matias": true,
      "San Miguelito": true,
      "San Rafael El Rosario": true,
      "Santa Cruz": true,
      "Santa Elena": true,
      "Shanshul": true,
      "Tiucal": true,
      "Tiucal Arriba": true,
      "Trapiche Abajo": true,
      "Trapiche Arriba": true,
      "Trapiche Vargas": true,
      "Valle Nuevo": true
    },
    "Yupiltepeque": {
      "El Calvario": true,
      "El Jocotillo": true,
      "El Sillon": true,
      "Estanzuela": true,
      "Jicaro": true,
      "Las Brisas": true,
      "Yupiltepeque": true
    },
    "Atescatempa": {
      "Amatepeque": true,
      "Atescatempa": true,
      "Contepeque": true,
      "El Naranjo": true,
      "El Rosario": true,
      "El Sitio": true,
      "Horcones": true,
      "La Gloria": true,
      "Las Vegas": true,
      "Los Cerritos": true,
      "San Cristobal Frontera": true,
      "Sansuque": true
    },
    "Jerez": {
      "El Saral": true,
      "El Sitio": true,
      "Escarbaderos": true,
      "Esmeralda": true,
      "Jerez": true
    },
    "El Adelanto": {
      "El Adelanto": true,
      "El Trapiche": true
    },
    "Zapotitlan": {
      "Cerro Redondo": true,
      "Zapotitlan": true
    },
    "Comapa": {
      "Caserio El Talpetate": true,
      "Comapa": true,
      "El Guachipilin": true,
      "El Pinal": true,
      "San Cristobal": true,
      "Santa Barbara": true
    },
    "Jalpatagua": {
      "Aceituno": true,
      "Aldea La Toma": true,
      "Azulco": true,
      "El Coco": true,
      "El Llano": true,
      "El Melonar": true,
      "El Retozadero": true,
      "El Rosario": true,
      "La Puerta": true,
      "Monzon": true,
      "San Francisco, Aldea": true,
      "San Ixtan": true,
      "Tierra Blanca": true,
      "Valle Nuevo Frontera": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true
    },
    "Moyuta": {
      "Ciudad Pedro De Alvarado": true,
      "Cofradias": true,
      "El Naranjo": true,
      "El Paraiso (Aldea)": true,
      "El Rodeo": true,
      "El Rosario (Aldea)": true,
      "El Salamar (Aldea)": true,
      "Garita Chapina (Aldea)": true,
      "La Laguna": true,
      "Los Achiotes": true,
      "Moyuta": true,
      "Santa Cruz": true
    },
    "Conguaco": {
      "Briotis, Caserio": true,
      "Caserio El Chile": true,
      "Conguaco": true,
      "El Bran": true,
      "Las Pilas": true,
      "San Pedro": true
    },
    "Pasaco": {
      "Pasaco": true
    },
    "San Jose Acatempa": {
      "Acatempa": true,
      "Calderas": true,
      "El Carpintero": true,
      "La Carretera": true,
      "Las Delicias": true,
      "Las Vegas": true,
      "Llano Grande": true,
      "San Jose Acatempa": true,
      "Tunillas": true
    },
    "Quezada": {
      "Bordo Alto": true,
      "Buena Vista": true,
      "Don Diego": true,
      "El Amaton": true,
      "El Jocote": true,
      "El Retiro": true,
      "El Rodeo": true,
      "El Tule": true,
      "Estoraque": true,
      "La Brea": true,
      "La Pava": true,
      "Las Palmeras": true,
      "Las Quebradas": true,
      "Los Comunes": true,
      "Los Ranchos": true,
      "Nuevo Chaparron": true,
      "Potrerillos": true,
      "Quezada": true,
      "Rio De Paz": true,
      "Salitrillo": true,
      "Santa Gertrudis": true,
      "Sarsalito": true,
      "Villa Hermosa": true,
      "Vista Hermosa": true
    }
  },
  "Petén": {
    "San Jose": {
      "San Jose Peten": true
    },
    "San Benito": {
      "San Benito": true,
      "Santa Cruz": true
    },
    "San Andres": {
      "La Ceibita": true,
      "San Andres Peten": true
    },
    "La Libertad": {
      "Aldea El Naranjo": true,
      "Caserio Las Flores": true,
      "Caserio Las Ruinas": true,
      "Cruce A La Candelaria": true,
      "Cruce Al Chocop": true,
      "Cruce El Ceibo": true,
      "Cruce El Toro": true,
      "El Aguacate": true,
      "El Ceibo": true,
      "El Esqueleto": true,
      "El Naranjo": true,
      "El Paraiso Km 107": true,
      "El Plantel": true,
      "La Bomba": true,
      "La Caoba": true,
      "La Gloria": true,
      "La Libertad": true,
      "La Llorona": true,
      "La Nueva Candelaria": true,
      "La Nueva Esperanza": true,
      "La Sabana": true,
      "Lagunitas": true,
      "Las Cruces Peten": true,
      "Las Cuaches": true,
      "Las Flores, ruta al Naranjo": true,
      "Las Marias": true,
      "Nueva Esperanza": true,
      "Nuevo Eden": true,
      "Nuevo San Jose": true,
      "Poza Del Macho": true,
      "Sagrado Corazón, ruta al Naranjo": true,
      "San Diego": true,
      "San Joaquin": true,
      "Santa Rita": true
    },
    "San Francisco": {
      "San Francisco": true,
      "San Francisco Peten": true,
      "San Juan De Dios": true
    },
    "Santa Ana": {
      "El Buen Retiro": true,
      "Santa Ana": true,
      "Santa Ana El Chal": true,
      "Santa Ana Nueva": true,
      "Santa Ana Peten": true,
      "Santa Ana Vieja": true
    },
    "Dolores": {
      "Aldea Cristo Rey": true,
      "Boca Del Monte": true,
      "Calzada Mopan Sabanetas": true,
      "Cristo Rey": true,
      "Dolores": true,
      "El Cabro Sabanetas": true,
      "El bombillo": true,
      "El manantial": true,
      "Grano de Oro": true,
      "Ixcoxol": true,
      "La Nueva Union Sabanetas": true,
      "La tarima": true,
      "Monte los Olivos": true,
      "Mopan III": true,
      "Nuevos Orizontes": true,
      "Sabanetas": true,
      "Santo Domingo": true,
      "Santo Toribio": true,
      "Yaltutu": true
    },
    "San Luis": {
      "Actela": true,
      "Bolocsocz": true,
      "Cain": true,
      "Cancis": true,
      "Chacalte": true,
      "Chacte": true,
      "Chimay": true,
      "Chinchila": true,
      "Cotochaj": true,
      "Cruce A Sajul": true,
      "Ixbobo": true,
      "Ixbobo nacimiento": true,
      "Jovente": true,
      "La Balza": true,
      "La Cahobita": true,
      "La Cumbre": true,
      "La Gloria": true,
      "La Tortuga": true,
      "La Union San Luis": true,
      "Las Cañas": true,
      "Los Angeles": true,
      "Pisula": true,
      "Quebrada Seca": true,
      "San Lucas el Aguacate": true,
      "San Luis": true,
      "Santa Cruz Frontera": true,
      "Santa Isabel (chinchila)": true,
      "Satul": true,
      "Secoyab": true,
      "Sehamay": true,
      "Sutija": true
    },
    "Sayaxche": {
      "Aldea El Paraiso": true,
      "Aldea El Pato": true,
      "Caserio El Mirador": true,
      "Caserio La Torre": true,
      "Caserio Los Olivos": true,
      "Cruce De Las Muñecas": true,
      "Cruce De Santotomas Y El Tamarindo": true,
      "El Eden": true,
      "El Nacimeinto": true,
      "El Rosario": true,
      "El Subin": true,
      "El Tucan": true,
      "La Ceiba": true,
      "La Ceibita": true,
      "La Linterna": true,
      "La Nueva Esperanza": true,
      "La Reynita": true,
      "La Soledad": true,
      "La Union El Poso": true,
      "Las Arenas": true,
      "Las Camelias": true,
      "Las Pacayas": true,
      "Las Pozas": true,
      "Las Salinas": true,
      "Linterna 2": true,
      "Nueva Libertad": true,
      "Rancho Alegre": true,
      "Rosa Jamaica": true,
      "Santa Rosa": true,
      "Sayaxche": true,
      "Tierra Blanca": true,
      "Tierra Linda Sayaxche": true
    },
    "Melchor de Mencos": {
      "Bajo Del Venado": true,
      "Cida Venque": true,
      "Cruce El Orquetero": true,
      "El Cruzadero": true,
      "El Ramonal, Ruta a Melchor": true,
      "La Polvora": true,
      "Melchor De Mencos": true,
      "Puerta Del Cielo": true
    },
    "Poptun": {
      "Canchacan": true,
      "Las Delicias": true,
      "Machaquila": true,
      "Poptun": true,
      "Poxte": true,
      "Santo Domingo": true,
      "Zona 1 poptun": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true,
      "Zona 7": true
    },
    "Las Cruces": {
      "El Naranjo, ruta a Melchor": true,
      "El Subin": true,
      "La Maquina, Ruta a Melchor": true,
      "Las Cruces": true,
      "Las Viñas, ruta a Melchor": true,
      "Palestina": true,
      "San Miguel (Otro lado del Lago)": true
    },
    "El Chal": {
      "Agricultores Unidos San Juan": true,
      "Colpeten": true,
      "EL Quetzalito": true,
      "El Chal": true,
      "El Juleque": true,
      "El Ocote": true,
      "El Quetzal": true,
      "El Rosalito": true,
      "La Machaca": true,
      "La Puente": true,
      "La Sardina": true,
      "Las Nuevas Delicias": true,
      "Las flores": true,
      "Los Angeles, Santa Ana, El Chal": true,
      "San Juan": true,
      "Santa Ana, El Chal": true,
      "Santa Isabel": true
    },
    "Flores": {
      "Altamira": true,
      "Caoba": true,
      "El Capulinar": true,
      "El Naranjo": true,
      "El Remate": true,
      "El Triunfo": true,
      "El Zapote": true,
      "Flores": true,
      "Ixlu": true,
      "La Maquina": true,
      "Las Viñas": true,
      "Los Tulipanes": true,
      "Macanche": true,
      "Paso Del Norte": true,
      "Paxcaman": true,
      "Porvenir Km.40": true,
      "Santa Elena": true,
      "Socotzal": true,
      "Tikal": true
    }
  },
  "Quetzaltenango": {
    "Quetzaltenango": {
      "Aldea Xecaracoj": true,
      "Chicua": true,
      "Chiquilaja": true,
      "Chitux": true,
      "Las Majadas": true,
      "Llanos del Pinal": true,
      "Quetzaltenango": true,
      "Xecaracoj": true,
      "Zona 01": true,
      "Zona 02": true,
      "Zona 03": true,
      "Zona 04": true,
      "Zona 05": true,
      "Zona 06": true,
      "Zona 07": true,
      "Zona 08": true,
      "Zona 09": true,
      "Zona 10": true,
      "Zona 11": true,
      "Zona 12": true
    },
    "Salcaja": {
      "Curruchique": true,
      "Marroquin": true,
      "Santa Rita": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "Olintepeque": {
      "Justo Rufino Barrios": true,
      "La Cumbre Olintepeque": true,
      "Olintepeque": true,
      "San Antonio Pajoc": true
    },
    "San Carlos Sija": {
      "Agua Caliente": true,
      "Calel": true,
      "Chicabal": true,
      "Chuatuj": true,
      "El Progreso": true,
      "Esquipulas Seque": true,
      "Estancia La Virgen": true,
      "Las Cruces": true,
      "Pachute": true,
      "Panorama": true,
      "Recuerdo A Barrios": true,
      "San Carlos Sija": true,
      "San Jose Chicalquix": true,
      "San Jose Chiquilaja": true,
      "San Jose El Rodeo": true
    },
    "Sibilia": {
      "Chuicabal": true,
      "El Rincon": true,
      "La Union": true,
      "Piedra Grande": true,
      "Sibilia": true
    },
    "Cabrican": {
      "Cabrican": true,
      "Cabricán El Cerro": true,
      "Corrales": true,
      "El Chorjale": true,
      "La Grandeza": true,
      "Las Cenagas": true,
      "Xajana": true,
      "Xecana": true
    },
    "Cajola": {
      "Cajola": true,
      "Cajola Chiquito": true
    },
    "San Miguel Siguila": {
      "La Emboscada": true,
      "San Miguel Sigüila": true
    },
    "San Juan Ostuncalco": {
      "Agua Blanca": true,
      "Agua Tibia": true,
      "Espumpuja": true,
      "La Nueva Concepcion": true,
      "La Reforma": true,
      "La Union": true,
      "Las Barrancas": true,
      "Las Lagunas Cuaches": true,
      "Los Alonzos": true,
      "Los Mendoza": true,
      "Monrovia": true,
      "Pueblo Nuevo": true,
      "Roble Grande": true,
      "Sigüila": true,
      "Varsobia": true,
      "Victoria": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "San Mateo": {
      "San Jose Pachimacho": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "Concepcion Chiquirichapa": {
      "Concepcion Chiquirichapa": true,
      "Los Duraznales": true
    },
    "San Martin Sacatepequez": {
      "El Rincon": true,
      "La Cumbre De Tui Lacan": true,
      "La Estancia": true,
      "Las Hortencias": true,
      "Las Nubes 1": true,
      "Las Nubes 2": true,
      "Loblatzan": true,
      "Nueva Concepcion": true,
      "San Martin Chiquito": true,
      "San Martin Sacatepequez": true,
      "Santa Ines": true,
      "Santo Domingo": true,
      "Toj Alic": true,
      "Toj Coman": true,
      "Tui Pic": true
    },
    "Almolonga": {
      "Las Delicias": true,
      "Los Baños": true,
      "San Agustin Pacayá": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Cantel": {
      "Chirijquiac": true,
      "Chuisuc": true,
      "La Estancia": true,
      "Pachaj": true,
      "Pasac 1": true,
      "Pasac 2": true,
      "Urbina": true,
      "Xecam": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Huitan": {
      "Huitancito": true,
      "Paxoj": true,
      "Vixben": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Zunil": {
      "Chicovix": true,
      "La Calera": true,
      "La Estancia De La Cruz": true,
      "Santa Maria De Jesus": true,
      "Tzumucubal": true,
      "Zunil": true
    },
    "Colomba": {
      "Colomba Costa Cuca": true,
      "Comunidad Agraria Las Mercedes": true
    },
    "San Francisco La Union": {
      "San Francisco La Union": true,
      "Xeaj": true
    },
    "El Palmar": {
      "El Palmar": true,
      "Nuevo Palmar": true
    },
    "Coatepeque": {
      "Aldea La Union": true,
      "Aldea La Unión": true,
      "Caserio Santa Ines, Coatepeque": true,
      "Chuatuj": true,
      "El Pital": true,
      "Las Palmas": true,
      "San Rafael 1 Y 2": true,
      "San Rafael Pacaya": true,
      "San Vicente Pacaya": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 6": true,
      "Zona 8": true
    },
    "Genova": {
      "Aldea El Manantial": true,
      "Aldea Morazan": true,
      "Genova": true,
      "San Miguelito": true,
      "Sector Juarez": true
    },
    "Flores Costa Cuca": {
      "Flores Costa Cuca": true
    },
    "La Esperanza": {
      "Santa Rita": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Palestina de los Altos": {
      "Buena Vista": true,
      "El Carmen": true,
      "El Eden": true,
      "Palestina De Los Altos": true
    }
  },
  "Quiché": {
    "Santa Cruz del Quiche": {
      "Aldea Santa Rosa": true,
      "Aldea la estancia": true,
      "Chitatul": true,
      "Choacaman 1": true,
      "Choacaman 2": true,
      "Choacaman 3": true,
      "Choacaman 4": true,
      "Pamesebal": true,
      "Panajxit": true,
      "Santa Cruz Del Quiche": true,
      "Xatinap 1": true,
      "Xatinap 2": true,
      "Xatinap 3": true,
      "Xatinap 4": true,
      "Xesic 1": true,
      "Xesic 2": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true
    },
    "Chiche": {
      "Capuchinas": true,
      "Chiche": true,
      "Choaxan I": true,
      "Choaxan Ii": true,
      "Rincon De Los Leones Sector I": true,
      "Rincon De Los Leones Sector Ii": true,
      "Trinidad": true
    },
    "Chinique": {
      "Agua Tibia I": true,
      "Agua Tibia Ii": true,
      "Chinique": true,
      "Choaxan": true,
      "Cordoncillo": true,
      "La Puerta": true,
      "Las Vigas": true,
      "Tapesquillo I": true,
      "Ximbaxuc I": true
    },
    "Zacualpa": {
      "Arriquin": true,
      "Chixocol": true,
      "La Vega": true,
      "Zacualpa": true
    },
    "Chajul": {
      "Chacalte": true,
      "Chajul": true,
      "Chel": true,
      "Ilom": true,
      "Xix": true,
      "Xolcuay": true
    },
    "Patzite": {
      "Chuamarcel": true,
      "Patzite": true
    },
    "San Antonio Ilotenango": {
      "San Antonio Ilotenango": true
    },
    "San Pedro Jocopilas": {
      "Chajbal": true,
      "San Pedro Jocopilas": true
    },
    "Cunen": {
      "Chiul": true,
      "Cunen": true,
      "El Pericon": true,
      "La Barranca": true,
      "La Hacienda": true,
      "Xemanzana": true
    },
    "San Juan Cotzal": {
      "Chichel": true,
      "Chisis": true,
      "Cotzal": true,
      "Rio Azul": true,
      "Xeputul": true
    },
    "Joyabaj": {
      "Joyabaj": true,
      "Los Llano": true,
      "Pachalib": true,
      "Tunaja": true
    },
    "San Andres Sajcabaja": {
      "Chinanton": true,
      "Chinilla": true,
      "Comitancillo": true,
      "Las Casas": true,
      "Lililla": true,
      "Quiché": true,
      "San Andres Sajcabaja": true
    },
    "Uspantan": {
      "Beleju": true,
      "El Palmar": true,
      "El Paraiso": true,
      "El Pinal": true,
      "Lancentillo": true,
      "Las Pacayas": true,
      "Uspantan": true
    },
    "Sacapulas": {
      "Guantajau": true,
      "Los Trapichitos": true,
      "Parraxtut": true,
      "Rancho De Teja": true,
      "Sacapulas": true,
      "San Jorge": true,
      "Tzununul": true
    },
    "San Bartolome Jocotenango": {
      "Los Cimientos": true,
      "San Bartolome Jocotenango": true
    },
    "Canilla": {
      "Canilla": true
    },
    "Chicaman": {
      "Beleju": true,
      "Calá": true,
      "Chicaman": true,
      "Chixiquin": true,
      "Chixoy": true,
      "Cumbre La May": true,
      "La Cruz Chixiquin": true,
      "Lancetillo La Parroqui": true,
      "Los Platanos": true,
      "Puente Seco": true
    },
    "Playa Grande Ixcan": {
      "Chicua": true,
      "Playa Grande Ixcan": true
    },
    "Pachalum": {
      "Aldea Potrero Grande": true,
      "Begonias": true,
      "Las Moritas": true,
      "Los Planes": true,
      "Pachalum": true,
      "Pamoca": true
    },
    "Nebaj": {
      "Acul": true,
      "Bicalama": true,
      "Chuatuj": true,
      "Ixtupil": true,
      "Nebaj": true,
      "Pulay": true,
      "Sacsiguan": true,
      "Salquil": true,
      "Sumal": true,
      "Tzalbal": true,
      "Vicalama": true,
      "Xonca": true
    },
    "Chichicastenango": {
      "Aldea Chicua": true,
      "Camachaj": true,
      "Camanibal": true,
      "Chichicastenango": true,
      "Chicua Primero": true,
      "Chicua Segundo": true,
      "Chicua Tercero": true,
      "Chuabaj": true,
      "Chupol": true,
      "Lacama Primero": true,
      "Lacama Segundo": true,
      "Lacama Tercero": true,
      "Mactzul": true,
      "Panimache 4": true,
      "Semeja Primero": true,
      "Semeja Segundo": true,
      "Semeja Tercero": true
    }
  },
  "Retalhuleu": {
    "Retalhuleu": {
      "Aldea Biloma": true,
      "Aldea Santa Fe": true,
      "Caballo Blanco": true,
      "Comunidad Agraria Valle Lirio": true,
      "Copepe": true,
      "El Retiro": true,
      "La Banquita": true,
      "Las Pilas": true,
      "Vaquilito": true,
      "Xula": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true,
      "Zona 6": true
    },
    "San Sebastian": {
      "Aldea Barrios": true,
      "Aldea Loma Linda": true,
      "Aldea Nimina": true,
      "Aldea San Luis": true,
      "San Sebastian, Retalhuleu": true
    },
    "Santa Cruz Mulua": {
      "Boxoma": true,
      "Lolita": true,
      "Santa Cruz Mulua": true
    },
    "San Martin Zapotitlan": {
      "Ceiba Blanca": true,
      "San Martin Zapotitlan": true
    },
    "San Felipe": {
      "Calahuache (Aldea)": true,
      "San Felipe Retalhuleu": true
    },
    "San Andres Villa Seca": {
      "Centro 2 La Maquina": true,
      "San Andres Villa Seca": true,
      "Tulate": true
    },
    "Champerico": {
      "Acapan": true,
      "Champerico": true,
      "Cuchuapan": true,
      "El Codo": true,
      "El Rosario": true,
      "La Guitarra": true,
      "La Tortuga": true,
      "Nueva Cajola": true,
      "Victorias El Salto": true
    },
    "Nuevo San Carlos": {
      "Candelaria Xolhuits": true,
      "Canton Jerez": true,
      "El Recuerdo Ocosito": true,
      "Granados": true,
      "La Libertad": true,
      "Montufar": true,
      "Nuevo San Carlos": true
    },
    "El Asintal": {
      "Cabañas": true,
      "El Asintal": true,
      "El Corcho": true,
      "El Xab": true,
      "Sibana": true
    }
  },
  "Sacatepéquez": {
    "Antigua Guatemala": {
      "Antigua Guatemala": true,
      "San Bartolome Becerra": true,
      "San Cristobal El Bajo": true,
      "San Felipe De Jesus": true,
      "San Isidro Sacatepequez": true,
      "San Juan Del Obispo": true,
      "San Juan Gascon": true,
      "San Lorenzo El Cubo": true,
      "San Miguel Escobar": true,
      "San Pedro Las Huertas": true,
      "Santa Ana Sacatepequez": true
    },
    "Jocotenango": {
      "Jocotenango": true
    },
    "Pastores": {
      "Pastores": true,
      "San Luis Las Carretas": true
    },
    "Sumpango": {
      "Sumpango": true
    },
    "Santo Domingo Xenacoj": {
      "Santo Domingo Xenacoj": true
    },
    "Santiago Sacatepequez": {
      "Santiago Sacatepequez": true
    },
    "San Bartolome Milpas Altas": {
      "San Bartolome Milpas Altas": true
    },
    "San Lucas Sacatepequez": {
      "San Lucas Sacatepequez": true,
      "Santa Maria Cauque": true
    },
    "Santa Lucia Milpas Altas": {
      "San Mateo Milpas Altas": true,
      "San Miguel Milpas Altas": true,
      "Santa Lucia Milpas Altas": true,
      "Santo Tomas Milpas Altas": true
    },
    "Magdalena Milpas Altas": {
      "Magdalena Milpas Altas": true
    },
    "Santa Maria de Jesus": {
      "Santa Maria De Jesus": true
    },
    "Ciudad Vieja": {
      "Ciudad Vieja": true
    },
    "San Miguel Dueñas": {
      "San Miguel Dueñas": true
    },
    "San Juan Alotenango": {
      "Alotenango": true,
      "San Juan Alotenango": true
    },
    "San Antonio Aguas Calientes": {
      "San Andres Ceballos": true,
      "San Antonio Aguas Calientes": true
    },
    "Santa Catarina Barahona": {
      "Santa Catarina Barahona": true
    }
  },
  "San Marcos": {
    "San Marcos": {
      "Aldea La Grandeza": true,
      "Caserio Ojo De Agua": true,
      "Caxaque": true,
      "El Recreo (Aldea)": true,
      "El Rincon": true,
      "La Federacion (Aldea)": true,
      "Las Lagunas (Aldea)": true,
      "San Rafael Soche": true,
      "San Sebastian": true,
      "Serchil": true,
      "Zona 1 San Marcos": true,
      "Zona 2": true,
      "Zona 3 San Marcos": true,
      "Zona 4 San Marcos": true,
      "Zona 5": true
    },
    "San Pedro Sacatepequez": {
      "Champollap": true,
      "La Grandeza": true,
      "Ojo De Agua": true,
      "Piedra Grande": true,
      "San Andres Chapil": true,
      "San Jose Caben": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Comitancillo": {
      "Comitancillo": true
    },
    "San Antonio Sacatepequez": {
      "San Antonio Sacatepequez": true
    },
    "San Miguel Ixtahuacan": {
      "Mina Marlin": true,
      "San Miguel Ixtahuacan": true
    },
    "Concepcion Tutuapa": {
      "Concepcion Tutuapa": true
    },
    "Tacana": {
      "Tacana": true
    },
    "Sibinal": {
      "Sibinal": true
    },
    "Tajumulco": {
      "Tajumulco": true
    },
    "Tejutla": {
      "Tejutla": true
    },
    "San Rafael Pie de la Cuesta": {
      "Chayen": true,
      "Pati": true,
      "San Rafael Pie De La Cuesta": true
    },
    "Nuevo Progreso": {
      "Nuevo Progreso": true,
      "Palin": true,
      "San Jeronimo": true,
      "San Miguel Pajapa": true
    },
    "El Tumbador": {
      "El Amparo": true,
      "El Tumbador": true
    },
    "El Rodeo": {
      "San Jose El Rodeo": true,
      "San José El Rodeo": true
    },
    "Malacatan": {
      "El Carmen": true,
      "Frontera El Carmen": true,
      "La Montaña Malacatán": true,
      "La Montañita": true,
      "Parcelamiento La Democracia": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true
    },
    "Catarina": {
      "Aldea El Tecomate": true,
      "Aldea Santa Rita": true,
      "Caserio Santa Barbara": true,
      "Catarina": true,
      "El Bejucal": true,
      "El Sitio": true,
      "El Tecomatillo": true,
      "La Muralla": true,
      "Las Pilas": true,
      "Nica": true,
      "Nicá": true,
      "Piedra Partida": true,
      "San Juan Melendrez": true
    },
    "Ayutla": {
      "El Alamo": true,
      "El Triunfo": true,
      "Las Delicias": true,
      "Los Angeles": true,
      "Sanjon San Lorenzo": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true
    },
    "Ocos": {
      "El Castaño": true,
      "La Blanca": true,
      "Limoncitos": true,
      "Limones": true,
      "Ocos": true,
      "Platanares": true,
      "Tilapa": true
    },
    "San Pablo": {
      "Comunidad El Porvenir": true,
      "La Cumbre": true,
      "San Pablo": true,
      "Tocache": true
    },
    "El Quetzal": {
      "El Quetzal": true
    },
    "La Reforma": {
      "La Reforma": true
    },
    "Pajapita": {
      "Nahuatan": true,
      "Pajapita": true
    },
    "Ixchiguan": {
      "Buenos Aires": true,
      "Calapte": true,
      "Choapequez": true,
      "Ixchiguan": true
    },
    "San Jose Ojetenam": {
      "San Jose Ojetenan": true
    },
    "San Cristobal Cucho": {
      "Barranca Grande": true,
      "San Cristobal Cucho": true
    },
    "Sipacapa": {
      "Canoj": true,
      "Pie De La Cuesta": true,
      "Queca": true,
      "Quesiguan": true,
      "Quexquesiguan": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Esquipulas Palo Gordo": {
      "Esquipulas Palo Gordo": true
    },
    "Rio Blanco": {
      "Rio Blanco": true
    },
    "San Lorenzo": {
      "San Lorenzo": true
    },
    "Tecun Uman": {
      "Tecun Uman": true
    },
    "La Blanca": {
      "Aldea Santa Irene": true,
      "Aldea Santa Rita": true,
      "Chiquirines": true,
      "La Blanca": true,
      "Los Cerritos": true,
      "Pueblo Nuevo": true,
      "Salinas 1": true,
      "Salinas 2": true,
      "San Isidro Chamac": true
    }
  },
  "Santa Rosa": {
    "Cuilapa": {
      "Aldea El Molino": true,
      "Aldea El Prado": true,
      "Cuilapa": true,
      "El Cielito": true,
      "El Reducto": true,
      "El Renacimiento": true,
      "Finca La Concepcion": true,
      "Las Victorias": true,
      "Los Esclavos": true,
      "Motecillos": true,
      "San Juan De Arana": true,
      "San Mateo, Aldea": true,
      "Valladares 1": true,
      "Valladares 2": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4, Cuilapa": true
    },
    "Barberena": {
      "El Cerinal": true,
      "El Junquillo": true,
      "El Naranjito": true,
      "El Pino": true,
      "El Quebracho": true,
      "La Vega": true,
      "Laguna del Pino": true,
      "Las Astas": true,
      "Las Pozas": true,
      "Monterroso, Caserio,": true,
      "Utzumazate": true,
      "Valle De San Fernando, Caserio": true,
      "Villas del Pino": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Santa Rosa de Lima": {
      "Amberes": true,
      "Cerro Gordo": true,
      "Chiapas": true,
      "El Carrizal": true,
      "El Rinconcito": true,
      "El Salitre": true,
      "La Casita": true,
      "Laguna De Pereira, Aldea": true,
      "Primera Sabana": true,
      "Pueblo Viejo, Aldea": true,
      "San Jose El Rinconcito": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Casillas": {
      "Ayarza": true,
      "Barrera": true,
      "Casillas": true,
      "El Arado": true,
      "El Salitre": true,
      "Guadalupe": true,
      "Las Minas": true,
      "Llano Grande": true,
      "Paso Caballos": true,
      "Pinalitos": true,
      "Pueblo Ralo": true,
      "San Juan Talpetate": true,
      "San Juan Tapalapa": true,
      "Tecuaco": true
    },
    "San Rafael Las Flores": {
      "Estanzuelas": true,
      "Los Planes": true,
      "Los Pocitos, Caserio": true,
      "Sabana Redonda": true,
      "San Rafael Las Flores": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Oratorio": {
      "Ceiba Gacha": true,
      "El Amatiyo": true,
      "El Mangon": true,
      "El Zapotillo": true,
      "Las Cabezas": true,
      "Las Marias": true,
      "Oratorio": true,
      "Santa Isabel, Aldea": true,
      "Zona 1": true
    },
    "San Juan Tecuaco": {
      "San Juan Tecuaco": true
    },
    "Chiquimulilla": {
      "Aldea San Antonito": true,
      "Aldea San Cristobal": true,
      "Cacahuito (Aldea)": true,
      "Casas Viejas": true,
      "Cerritos": true,
      "Chapeton (Aldea)": true,
      "Chiquimulilla": true,
      "El Aguacate (Aldea)": true,
      "El Ahumado (Aldea)": true,
      "El Astillero": true,
      "El Campamento": true,
      "El Chapeton": true,
      "El Obraje": true,
      "El Toro": true,
      "Finca San Francisco": true,
      "La Faja": true,
      "La Ginebra": true,
      "La Sarampaña": true,
      "Las Flores (Caserio)": true,
      "Las Lisas": true,
      "Los Cerritos": true,
      "Madre Vieja (Aldea)": true,
      "Margaritas": true,
      "Nancinta (Aldea)": true,
      "Placetas": true,
      "Playa Las Lisas": true,
      "Posa De Llano": true,
      "San Juan Tecuaco": true,
      "San Rafael (Aldea)": true,
      "San Rafael Las Flores (aldea)": true,
      "Santa Rosa (Aldea)": true
    },
    "Taxisco": {
      "El Arenal": true,
      "El Astillero": true,
      "El Cacahuito": true,
      "El Cebollito": true,
      "El Sunso": true,
      "Hawaii": true,
      "La Avellana": true,
      "La Barrona (Aldea)": true,
      "La Candelaria": true,
      "La Curvina": true,
      "La Libertad": true,
      "Las Quechas": true,
      "Las Violetas Del Jobo": true,
      "Monterrico": true,
      "Puerto Viejo": true,
      "Taxisco": true
    },
    "Santa Maria Ixhuatan": {
      "Estanzuelas": true,
      "La Esperanza": true,
      "Llano Grande": true,
      "Los Hatios": true,
      "Santa Maria Ixhuatan": true
    },
    "Guazacapan": {
      "El Astillero": true,
      "Guazacapan": true,
      "Platanares": true,
      "Poza De Agua Guazacapan": true
    },
    "Santa Cruz Naranjo": {
      "Agua Blanca": true,
      "Don Gregorio": true,
      "El Carmen": true,
      "El Encinon": true,
      "El Junquillo": true,
      "El Naranjo": true,
      "El Potrerio": true,
      "El Teocinte": true,
      "Finca Brito": true,
      "Joyas De Brito": true,
      "Santa Cruz Naranjo": true
    },
    "Pueblo Nuevo Viñas": {
      "El Cuje Pueblo Nuevo Viñas": true,
      "La Joya": true,
      "Las Lomas, Aldea": true,
      "Montufar": true,
      "San Miguel, Caserio": true,
      "San Sebastian": true,
      "Zona 1": true,
      "Zona 2": true
    },
    "Nueva Santa Rosa": {
      "Aldea Chapas": true,
      "Aldea El Riachuelo": true,
      "El Chiltepe, Chapas": true,
      "El Chupadero": true,
      "Espitia Barrera": true,
      "Espitia Real": true,
      "Estanzuelas": true,
      "Jumaytepeque": true,
      "La Joya": true,
      "Nueva Santa Rosa": true,
      "Palin": true,
      "Portezuelos, Aldea": true,
      "Zona 1": true,
      "Zona 2": true
    }
  },
  "Solola": {
    "Solola": {
      "Aldea Argueta": true,
      "Argueta": true,
      "Buena Vista.": true,
      "Canton Patzutzun": true,
      "Chaquijyá": true,
      "Chuaxic": true,
      "Chuiquel": true,
      "Consepcion": true,
      "El Tablón": true,
      "Los Encuentros": true,
      "Maria Tecun": true,
      "Monte Mercedez": true,
      "Pixabaj": true,
      "Pujujil": true,
      "Sacsiguán": true,
      "San Isidro": true,
      "San Jorge La Laguna": true,
      "Solola": true,
      "Xajaxac": true,
      "Xaquijya": true
    },
    "San Jose Chacaya": {
      "Las Minas": true,
      "San Jose Chacaya": true
    },
    "Santa Maria Visitacion": {
      "Canton Xiprian": true,
      "Santa Maria Visitacion": true
    },
    "Santa Lucia Utatlan": {
      "Campo Verde": true,
      "Canton Chiuquel": true,
      "Canton Pamesabal": true,
      "Canton Tzucubalbe": true,
      "Canton Ventana Abajo": true,
      "Chichimuch": true,
      "Chuimacha": true,
      "La Esperanza Santa Lucia Utatlan": true,
      "Los Manantiales": true,
      "Los Planes": true,
      "Los Tablones": true,
      "Novillero": true,
      "Pahaj": true,
      "Paracana": true,
      "Santa Lucia Utatlan": true
    },
    "Nahuala": {
      "Chuachinup": true,
      "Nahuala": true,
      "Pachipac": true,
      "Pacoxom": true,
      "Palacal": true,
      "Palanquix Loma": true,
      "Paquila": true,
      "Patzij": true,
      "Racantacaj": true,
      "Tzamjuyup": true,
      "Tzanjuyub": true,
      "Xejuyup": true,
      "Xojolá": true
    },
    "Santa Catarina Ixtahuacan": {
      "Chirijox": true,
      "Guineales": true,
      "Pacaman": true,
      "Santa Catarina Ixtahuacan": true,
      "Tzucubal": true
    },
    "Santa Clara La Laguna": {
      "Chacap": true,
      "Palestina (en Santa Clara La Laguna)": true,
      "Panyevar": true,
      "Santa Clara La Laguna": true,
      "Xibalbay": true
    },
    "Concepcion": {
      "Canton Pujujilito": true
    },
    "San Andres Semetabaj": {
      "Canton Panimatzalam": true,
      "Carretera A las Trampas Km124": true,
      "Choquec": true,
      "El Roble": true,
      "Godínez": true,
      "Las Canoas Altas": true,
      "Las Cruces": true,
      "Los Canoas Bajas": true,
      "San Andres Semetabaj": true,
      "Sejuyu Primero": true,
      "Sejuyu Segundo": true,
      "Tocache": true,
      "Xecotoj": true,
      "Xejuyp": true,
      "Xequistel": true
    },
    "Panajachel": {
      "Canton Jucanya": true,
      "Panajachel": true,
      "Patanatic": true,
      "San Luis": true
    },
    "Santa Catarina Palopo": {
      "Santa Catarina Palopo": true
    },
    "San Antonio Palopo": {
      "Agua Escondida": true,
      "Canton Chuiquistel": true,
      "El Maranjo": true,
      "San Antonio Palopo": true,
      "San Gabriel": true,
      "San Jose Xiquinabaj": true
    },
    "San Lucas Toliman": {
      "Chitulul": true,
      "Pachitulul": true,
      "Pampojila": true,
      "Panaranjo": true,
      "Panimaquip": true,
      "Quixaja": true,
      "San Lucas Toliman": true
    },
    "Santa Cruz La Laguna": {
      "Jaibalito": true,
      "Santa Cruz La Laguna": true,
      "Tzuruna": true
    },
    "San Pablo La Laguna": {
      "San Pablo La Laguna": true
    },
    "San Marcos La Laguna": {
      "San Marcos la Laguna": true
    },
    "San Juan La Laguna": {
      "San Juan La Laguna": true
    },
    "San Pedro La Laguna": {
      "San Pedro La Laguna": true
    },
    "Santiago Atitlan": {
      "Aldea Cerro De Oro": true,
      "Cerro De Oro": true,
      "Chucumuc 1": true,
      "Chucumuc 2": true,
      "Chucumuc 3": true,
      "Paguacal": true,
      "Panabaj": true,
      "San Antonio Chacaya": true,
      "San Chaj": true,
      "Santiago Atitlan": true,
      "Xechivoy": true
    }
  },
  "Suchitepéquez": {
    "Mazatenango": {
      "Aldea Tierra Del Pueblo": true,
      "Canton Cocales": true,
      "Guatalon": true,
      "Mazatenango": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Cuyotenango": {
      "Canton Chacalte Aparicio": true,
      "Centro I La Maquina": true,
      "Churirin": true,
      "Cuyotenango": true,
      "Entre Rios": true
    },
    "San Francisco Zapotitlan": {
      "San Francisco Zapotitlan": true
    },
    "San Bernardino": {
      "San Bernardino": true
    },
    "San Jose El Idolo": {
      "San Jose El Idolo": true
    },
    "Santo Domingo": {
      "Aldea Belen": true,
      "Aldea Monterrey": true,
      "Canton El Copado": true,
      "Japon Nacional": true,
      "La Esperanza": true,
      "La Providencia": true,
      "Montecristo": true,
      "Parcelamiento San Mauricio": true,
      "San Jose Los Tiestos": true,
      "Santo Domingo Suchitepequez": true,
      "Willy Wood": true
    },
    "San Lorenzo": {
      "San Lorenzo Suchitepequez": true
    },
    "Samayac": {
      "Chihuaste": true,
      "Samayac": true
    },
    "San Pablo Jocopilas": {
      "Comunidad Agraria Madre Mia": true,
      "La Ladrillera": true,
      "San Pablo Jocopilas": true
    },
    "San Antonio Suchitepequez": {
      "Concepcion Ixtacapa": true,
      "Finca Palofox": true,
      "San Antonio Suchitepequez": true
    },
    "San Miguel Panan": {
      "San Miguel Panan": true
    },
    "San Gabriel": {
      "San Gabriel": true
    },
    "Chicacao": {
      "Chicacao": true,
      "Nahualate": true,
      "San Pedro Cutzam": true
    },
    "Patulul": {
      "Cocales": true,
      "Colonia 15 de Octubre": true,
      "Patulul": true
    },
    "Santa Barbara": {
      "El Guayabal": true,
      "San Fernando Chipo": true,
      "Santa Barbara": true
    },
    "San Juan Bautista": {
      "San Juan Bautista": true
    },
    "Santo Tomas La Union": {
      "Chocola": true,
      "Santo Tomas La Union": true
    },
    "Zunilito": {
      "Zunilito": true
    },
    "Pueblo Nuevo": {
      "Belen": true,
      "La Dicha": true,
      "Las Marias Pueblo Nuevo": true,
      "Pueblo Nuevo": true
    },
    "Rio Bravo": {
      "Rio Bravo": true
    }
  },
  "Totonicapán": {
    "Totonicapan": {
      "Aldea Chimente": true,
      "Aldea Vasquez": true,
      "Bareneche": true,
      "Canton Chotacaj": true,
      "Canton Chuisuc": true,
      "Canton Juchanep": true,
      "Canton Nimapa": true,
      "Canton Paqui": true,
      "Canton Poxlajuj": true,
      "Canton Xesacmalja": true,
      "Canton Xolsacmalja": true,
      "Chipuac": true,
      "Chiyax": true,
      "Chotacaj": true,
      "Chuanuj": true,
      "Chuatroj": true,
      "Chuisacmaja": true,
      "Coxom": true,
      "Juchanep": true,
      "La Concardia": true,
      "La Esperanza": true,
      "Nimasac": true,
      "Pachoc": true,
      "Panquix": true,
      "Paqui": true,
      "Tierra Blanca": true,
      "Totonicapan": true,
      "Vasquez": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "San Cristobal": {
      "Candelaria": true,
      "Chajabaj": true,
      "Cuatro Caminos": true,
      "La Cienaga": true,
      "Nueva Candelaria": true,
      "Pacanac": true,
      "Patachaj": true,
      "Paxtoca": true,
      "San Cristobal Totonicapan": true,
      "San Ramon": true,
      "Xecanchavox": true,
      "Xesuc": true
    },
    "San Francisco El Alto": {
      "Canton Pachaj": true,
      "Chirrenox": true,
      "Chivarreto": true,
      "Choacorral": true,
      "Chuasiguan": true,
      "Pabatoc": true,
      "Pachaj": true,
      "Paxixil": true,
      "Rancho De Teja": true,
      "Sacmixit": true,
      "San Antonio Sija": true,
      "San Francisco El Alto": true,
      "Tacajalve": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true,
      "Zona 5": true
    },
    "San Andres Xecul": {
      "Chajabal": true,
      "Nimasac": true,
      "Palomora": true,
      "San Andres Xecul": true,
      "Xejuyub": true
    },
    "Momostenango": {
      "Chicorral": true,
      "Chinimabe": true,
      "La Cumbre": true,
      "Los Cipreses": true,
      "Momostenango": true,
      "Nicaja": true,
      "Patulup": true,
      "Pitzal": true,
      "Pologua": true,
      "Pueblo Viejo": true,
      "San Antonio Pasajoc": true,
      "San Vicente Buenabaj": true,
      "Santa Ana": true,
      "Tierra Blanca": true,
      "Tierra Colorada": true,
      "Tunayac": true,
      "Tzanjon": true,
      "Xequemeya": true,
      "Xolajap": true,
      "Xolbe": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Santa Maria Chiquimula": {
      "Barrio Chisiguan": true,
      "Barrio Chuisactol": true,
      "Casa Blanca": true,
      "Chuachituj": true,
      "Chuacorral I": true,
      "Chuacorral Ii": true,
      "Chuacorral Iii": true,
      "Chuiaj": true,
      "Chuicaca": true,
      "El Rancho": true,
      "Patzam": true,
      "Santa Maria Chiquimula": true,
      "Xacona": true,
      "Xeb'E": true,
      "Xecachelaj": true,
      "Xecaja": true,
      "Xecococh": true,
      "Xesana": true
    },
    "Santa Lucia La Reforma": {
      "Santa Lucía La Reforma": true
    },
    "San Bartolo Aguas Calientes": {
      "Pueblo Viejo Km 225": true,
      "Parraxchaj": true,
      "Paxboch": true,
      "San Bartolo": true,
      "Tierra Blanca": true,
      "Tzanjon": true
    }
  },
  "Zacapa": {
    "Zacapa": {
      "Agua Blanca": true,
      "Barranco Colorado": true,
      "Barrio La Calzada": true,
      "Caserio El Palmar": true,
      "Colonia Banvi": true,
      "Colonia El Chaparro": true,
      "Colonia El Manantial": true,
      "Colonia Elim": true,
      "Colonia Pocará": true,
      "Conevisa": true,
      "Cruz De Mayo": true,
      "El Frutillo": true,
      "El Maestro": true,
      "El Maguey": true,
      "El Manantial": true,
      "El Mitch": true,
      "El Mitch La Fragua": true,
      "El Terrero": true,
      "El Trapiche": true,
      "Esmeralda": true,
      "Jampu": true,
      "Jumuzna Abajo": true,
      "Jumuzna Arriba": true,
      "La Calzada": true,
      "La Laguneta": true,
      "La Majada": true,
      "La Trementina": true,
      "Las Brisas": true,
      "Las Flores": true,
      "Llano De Calderón": true,
      "Llano De Piedra": true,
      "Los Jocotes": true,
      "Manzanotes": true,
      "Nopalera": true,
      "Pie De La Cuesta": true,
      "Puente Blanco": true,
      "Punilá": true,
      "Residenciales Eduardo": true,
      "Residenciales San José": true,
      "San Felipe": true,
      "San Juan": true,
      "San Pablo": true,
      "Santa Lucia": true,
      "Santa Marta": true,
      "Santa Rosalia": true,
      "Tablones": true,
      "Tres Cruces": true,
      "Villas Doña Luisa": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Rio Hondo": {
      "Agua Caliente": true,
      "Aldea Chanchan": true,
      "Casas De Pinto": true,
      "Caserio La Ceibita": true,
      "Caserio Puente Marmol": true,
      "El Peton": true,
      "El Rosario": true,
      "Jesus Maria": true,
      "Jones": true,
      "Juan Ponce": true,
      "Jumuzna": true,
      "La Arenera": true,
      "La Espinilla": true,
      "La Palma": true,
      "La Pepesca": true,
      "Las Delicias": true,
      "Las Joyas": true,
      "Las Pozas": true,
      "Llano Largo": true,
      "Llano Verde": true,
      "Lo De Mejia": true,
      "Mal Paso": true,
      "Monte Grande": true,
      "Ojo De Agua": true,
      "Pasabien": true,
      "Pata Galana": true,
      "Rio Hondo": true,
      "Santa Cruz": true,
      "Senegal": true,
      "Sunsapote Abajo": true,
      "Sunsapote Arriba": true
    },
    "Gualan": {
      "Aldea Los Achiotes": true,
      "Aldea Samaria": true,
      "Chinchin": true,
      "Conacaste": true,
      "Doña Maria": true,
      "El Arenal": true,
      "El Cacao": true,
      "El Chupadero": true,
      "El Filo": true,
      "El Jute": true,
      "El Lobo": true,
      "El Mestizo": true,
      "Encinitos": true,
      "Garcia": true,
      "Gualan": true,
      "Guayabal": true,
      "La Vainilla": true,
      "Las Carretas": true,
      "Las Verapaces": true,
      "Llano Largo": true,
      "Llano Redondo": true,
      "Los Limones": true,
      "Manzanotal": true,
      "Mayuelas": true,
      "Nueva Esperanza": true,
      "Piedras Azules": true,
      "Santa Maria": true,
      "Santiago": true,
      "Sarzal": true,
      "Tempisque": true,
      "Viafra": true
    },
    "Teculutan": {
      "Astillero": true,
      "Bajada Del Río": true,
      "Barranca Seca": true,
      "Barranco Colorado": true,
      "Barrio El Calvario": true,
      "Barrio El Paraíso": true,
      "Barrio Nuevo": true,
      "Barrio San José": true,
      "Colonia El Milagro I": true,
      "Colonia El Milagro II": true,
      "Colonia G&amp;T": true,
      "Colonia Habitat": true,
      "Colonia Jardines De Tecolotlán": true,
      "Colonia Marcial Castañeda": true,
      "Colonia Maribel": true,
      "Colonia Victor Hugo Paiz": true,
      "El Arco": true,
      "El Astillero": true,
      "El Oreganal": true,
      "El Remolino": true,
      "El Yajal": true,
      "La Paz": true,
      "Las Anonas": true,
      "Las Minas": true,
      "Los Bordos": true,
      "Los Palmares": true,
      "Los Puentes": true,
      "Lotificación La Máquina": true,
      "Lotificación Prados De Teculután": true,
      "Lotificación Puerta De Alcalá": true,
      "Puerta De Golpe": true,
      "San Antonio": true,
      "San José": true,
      "Vega Del Coban": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "Usumatlan": {
      "El Jute": true,
      "El Maguey": true,
      "Huijo": true,
      "La Palmilla": true,
      "Pueblo Nuevo": true,
      "Rio Chiquito": true,
      "Usumatlan": true
    },
    "Cabañas": {
      "Achiotes": true,
      "Cabañas": true,
      "El Arenal": true,
      "El Rosario": true,
      "El Tambor": true,
      "La Laguna": true,
      "La Puente": true,
      "Quebrada Honda": true,
      "San Luis": true,
      "San Vicente": true
    },
    "San Diego": {
      "El Monjon": true,
      "El Paraiso": true,
      "El Porvenir": true,
      "El Terrero": true,
      "El Triunfo": true,
      "La Ensenada": true,
      "San Antonio Las Lomas": true,
      "San Diego": true,
      "Santa Elena": true,
      "Venecia": true
    },
    "La Union": {
      "Chaguiton": true,
      "El Chile": true,
      "La Union": true,
      "Tres Pinos": true
    },
    "Huite": {
      "Antombran": true,
      "Huite": true,
      "La Reforma": true,
      "Reforma": true
    },
    "Estanzuela": {
      "Aldea Chispan": true,
      "Aldea Tecolote": true,
      "Candelaria": true,
      "Cocales": true,
      "Colonia Cordón": true,
      "Colonia San Francisco": true,
      "Currumiches": true,
      "El Museo": true,
      "El Oasis": true,
      "Estanzuela": true,
      "Guadalupe": true,
      "Guayabal": true,
      "La Puntilla": true,
      "Las Canchitas": true,
      "Las Quebradas": true,
      "Las Rositas": true,
      "San Cayetano": true,
      "San Nicolás": true,
      "Santa Cecilia": true,
      "Zona 1": true,
      "Zona 2": true,
      "Zona 3": true,
      "Zona 4": true
    },
    "San Jorge": {
      "La Fragua": true,
      "La Laguna": true,
      "San Jorge": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}